import { defineMessages } from 'react-intl';

const defaultLocale = 'en';

const defaultMessages = defineMessages({
  activerecordAttributesUserCurrentPassword: {
    id: 'activerecord.attributes.user.current_password',
    defaultMessage: 'Current password',
  },
  activerecordAttributesUserEmail: {
    id: 'activerecord.attributes.user.email',
    defaultMessage: 'Email',
  },
  activerecordAttributesUserPassword: {
    id: 'activerecord.attributes.user.password',
    defaultMessage: 'Password',
  },
  activerecordAttributesUserPasswordConfirmation: {
    id: 'activerecord.attributes.user.password_confirmation',
    defaultMessage: 'Password confirmation',
  },
  activerecordAttributesUserRememberMe: {
    id: 'activerecord.attributes.user.remember_me',
    defaultMessage: 'Remember me',
  },
  activerecordAttributesUserResetPasswordToken: {
    id: 'activerecord.attributes.user.reset_password_token',
    defaultMessage: 'Reset password token',
  },
  activerecordAttributesUserUnlockToken: {
    id: 'activerecord.attributes.user.unlock_token',
    defaultMessage: 'Unlock token',
  },
  activerecordModelsUser: {
    id: 'activerecord.models.user',
    defaultMessage: 'User',
  },
  deviseSessionsSignedIn: {
    id: 'devise.sessions.signed_in',
    defaultMessage: '',
  },
  deviseSessionsSignedOut: {
    id: 'devise.sessions.signed_out',
    defaultMessage: '',
  },
  usersConfirmationsConfirmed: {
    id: 'users.confirmations.confirmed',
    defaultMessage: 'Your email address has been successfully confirmed.',
  },
  usersConfirmationsNewResendConfirmationInstructions: {
    id: 'users.confirmations.new.resend_confirmation_instructions',
    defaultMessage: 'Resend confirmation instructions',
  },
  usersConfirmationsSendInstructions: {
    id: 'users.confirmations.send_instructions',
    defaultMessage:
      'You will receive an email with instructions for how to confirm your email address in a few minutes.',
  },
  usersConfirmationsSendParanoidInstructions: {
    id: 'users.confirmations.send_paranoid_instructions',
    defaultMessage:
      'If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes.',
  },
  usersFailureAlreadyAuthenticated: {
    id: 'users.failure.already_authenticated',
    defaultMessage: 'You are already signed in.',
  },
  usersFailureInactive: {
    id: 'users.failure.inactive',
    defaultMessage: 'Your account is not activated yet.',
  },
  usersFailureInvalid: {
    id: 'users.failure.invalid',
    defaultMessage: 'Invalid email or password.',
  },
  usersFailureLastAttempt: {
    id: 'users.failure.last_attempt',
    defaultMessage: 'You have one more attempt before your account is locked.',
  },
  usersFailureLocked: {
    id: 'users.failure.locked',
    defaultMessage: 'Your account is locked.',
  },
  usersFailureNotFoundInDatabase: {
    id: 'users.failure.not_found_in_database',
    defaultMessage: 'Invalid email address or password.',
  },
  usersFailureTimeout: {
    id: 'users.failure.timeout',
    defaultMessage: 'Your session expired. Please sign in again to continue.',
  },
  usersFailureUnauthenticated: {
    id: 'users.failure.unauthenticated',
    defaultMessage: 'You need to sign in or sign up before continuing.',
  },
  usersFailureUnconfirmed: {
    id: 'users.failure.unconfirmed',
    defaultMessage: 'You have to confirm your email address before continuing.',
  },
  usersMailerConfirmationInstructionsAction: {
    id: 'users.mailer.confirmation_instructions.action',
    defaultMessage: 'Confirm my account',
  },
  usersMailerConfirmationInstructionsGreeting: {
    id: 'users.mailer.confirmation_instructions.greeting',
    defaultMessage: 'Welcome {recipient}!',
  },
  usersMailerConfirmationInstructionsInstruction: {
    id: 'users.mailer.confirmation_instructions.instruction',
    defaultMessage:
      'You can confirm your account email through the link below:',
  },
  usersMailerConfirmationInstructionsSubject: {
    id: 'users.mailer.confirmation_instructions.subject',
    defaultMessage: 'Confirmation instructions',
  },
  usersMailerPasswordChangeGreeting: {
    id: 'users.mailer.password_change.greeting',
    defaultMessage: 'Hello {recipient}!',
  },
  usersMailerPasswordChangeMessage: {
    id: 'users.mailer.password_change.message',
    defaultMessage:
      "We're contacting you to notify you that your password has been changed.",
  },
  usersMailerPasswordChangeSubject: {
    id: 'users.mailer.password_change.subject',
    defaultMessage: 'Password Changed',
  },
  usersMailerResetPasswordInstructionsAction: {
    id: 'users.mailer.reset_password_instructions.action',
    defaultMessage: 'Change my password',
  },
  usersMailerResetPasswordInstructionsGreeting: {
    id: 'users.mailer.reset_password_instructions.greeting',
    defaultMessage: 'Hello {recipient}!',
  },
  usersMailerResetPasswordInstructionsInstruction: {
    id: 'users.mailer.reset_password_instructions.instruction',
    defaultMessage:
      'Someone has requested a link to change your password, and you can do this through the link below.',
  },
  usersMailerResetPasswordInstructionsInstruction2: {
    id: 'users.mailer.reset_password_instructions.instruction_2',
    defaultMessage: "If you didn't request this, please ignore this email.",
  },
  usersMailerResetPasswordInstructionsInstruction3: {
    id: 'users.mailer.reset_password_instructions.instruction_3',
    defaultMessage:
      "Your password won't change until you access the link above and create a new one.",
  },
  usersMailerResetPasswordInstructionsSubject: {
    id: 'users.mailer.reset_password_instructions.subject',
    defaultMessage: 'Reset password instructions',
  },
  usersMailerUnlockInstructionsAction: {
    id: 'users.mailer.unlock_instructions.action',
    defaultMessage: 'Unlock my account',
  },
  usersMailerUnlockInstructionsGreeting: {
    id: 'users.mailer.unlock_instructions.greeting',
    defaultMessage: 'Hello {recipient}!',
  },
  usersMailerUnlockInstructionsInstruction: {
    id: 'users.mailer.unlock_instructions.instruction',
    defaultMessage: 'Click the link below to unlock your account:',
  },
  usersMailerUnlockInstructionsMessage: {
    id: 'users.mailer.unlock_instructions.message',
    defaultMessage:
      'Your account has been locked due to an excessive amount of unsuccessful sign in attempts.',
  },
  usersMailerUnlockInstructionsSubject: {
    id: 'users.mailer.unlock_instructions.subject',
    defaultMessage: 'Unlock instructions',
  },
  usersOmniauthCallbacksFailure: {
    id: 'users.omniauth_callbacks.failure',
    defaultMessage:
      'Could not authenticate you from {kind} because "{reason}".',
  },
  usersOmniauthCallbacksSuccess: {
    id: 'users.omniauth_callbacks.success',
    defaultMessage: 'Successfully authenticated from {kind} account.',
  },
  usersPasswordsEditChangeMyPassword: {
    id: 'users.passwords.edit.change_my_password',
    defaultMessage: 'Change my password',
  },
  usersPasswordsEditChangeYourPassword: {
    id: 'users.passwords.edit.change_your_password',
    defaultMessage: 'Change your password',
  },
  usersPasswordsEditConfirmNewPassword: {
    id: 'users.passwords.edit.confirm_new_password',
    defaultMessage: 'Confirm new password',
  },
  usersPasswordsEditNewPassword: {
    id: 'users.passwords.edit.new_password',
    defaultMessage: 'New password',
  },
  usersPasswordsNewForgotYourPassword: {
    id: 'users.passwords.new.forgot_your_password',
    defaultMessage: 'Forgot your password?',
  },
  usersPasswordsNewSendMeResetPasswordInstructions: {
    id: 'users.passwords.new.send_me_reset_password_instructions',
    defaultMessage: 'Send me reset password instructions',
  },
  usersPasswordsNoToken: {
    id: 'users.passwords.no_token',
    defaultMessage:
      "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
  },
  usersPasswordsSendInstructions: {
    id: 'users.passwords.send_instructions',
    defaultMessage:
      'You will receive an email with instructions on how to reset your password in a few minutes.',
  },
  usersPasswordsSendParanoidInstructions: {
    id: 'users.passwords.send_paranoid_instructions',
    defaultMessage:
      'If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.',
  },
  usersPasswordsUpdated: {
    id: 'users.passwords.updated',
    defaultMessage:
      'Your password has been changed successfully. You are now signed in.',
  },
  usersPasswordsUpdatedNotActive: {
    id: 'users.passwords.updated_not_active',
    defaultMessage: 'Your password has been changed successfully.',
  },
  usersRegistrationsDestroyed: {
    id: 'users.registrations.destroyed',
    defaultMessage:
      'Bye! Your account has been successfully cancelled. We hope to see you again soon.',
  },
  usersRegistrationsEditAreYouSure: {
    id: 'users.registrations.edit.are_you_sure',
    defaultMessage: 'Are you sure?',
  },
  usersRegistrationsEditCancelMyAccount: {
    id: 'users.registrations.edit.cancel_my_account',
    defaultMessage: 'Cancel my account',
  },
  usersRegistrationsEditCurrentlyWaitingConfirmationForEmail: {
    id: 'users.registrations.edit.currently_waiting_confirmation_for_email',
    defaultMessage: 'Currently waiting confirmation for: {email}',
  },
  usersRegistrationsEditLeaveBlankIfYouDonTWantToChangeIt: {
    id: 'users.registrations.edit.leave_blank_if_you_don_t_want_to_change_it',
    defaultMessage: "leave blank if you don't want to change it",
  },
  usersRegistrationsEditTitle: {
    id: 'users.registrations.edit.title',
    defaultMessage: 'Edit {resource}',
  },
  usersRegistrationsEditUnhappy: {
    id: 'users.registrations.edit.unhappy',
    defaultMessage: 'Unhappy?',
  },
  usersRegistrationsEditUpdate: {
    id: 'users.registrations.edit.update',
    defaultMessage: 'Update',
  },
  usersRegistrationsEditWeNeedYourCurrentPasswordToConfirmYourChanges: {
    id: 'users.registrations.edit.we_need_your_current_password_to_confirm_your_changes',
    defaultMessage: 'we need your current password to confirm your changes',
  },
  usersRegistrationsNewSignUp: {
    id: 'users.registrations.new.sign_up',
    defaultMessage: 'Sign up',
  },
  usersRegistrationsSignedUp: {
    id: 'users.registrations.signed_up',
    defaultMessage: 'Welcome! You have signed up successfully.',
  },
  usersRegistrationsSignedUpButInactive: {
    id: 'users.registrations.signed_up_but_inactive',
    defaultMessage:
      'You have signed up successfully. However, we could not sign you in because your account is not yet activated.',
  },
  usersRegistrationsSignedUpButLocked: {
    id: 'users.registrations.signed_up_but_locked',
    defaultMessage:
      'You have signed up successfully. However, we could not sign you in because your account is locked.',
  },
  usersRegistrationsSignedUpButUnconfirmed: {
    id: 'users.registrations.signed_up_but_unconfirmed',
    defaultMessage:
      'A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.',
  },
  usersRegistrationsUpdateNeedsConfirmation: {
    id: 'users.registrations.update_needs_confirmation',
    defaultMessage:
      'You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirm link to confirm your new email address.',
  },
  usersRegistrationsUpdated: {
    id: 'users.registrations.updated',
    defaultMessage: 'Your account has been updated successfully.',
  },
  usersSessionsAlreadySignedOut: {
    id: 'users.sessions.already_signed_out',
    defaultMessage: 'Signed out successfully.',
  },
  usersSessionsNewSignIn: {
    id: 'users.sessions.new.sign_in',
    defaultMessage: 'Sign in',
  },
  usersSessionsSignedIn: { id: 'users.sessions.signed_in', defaultMessage: '' },
  usersSessionsSignedOut: {
    id: 'users.sessions.signed_out',
    defaultMessage: '',
  },
  usersSharedLinksBack: {
    id: 'users.shared.links.back',
    defaultMessage: 'Back',
  },
  usersSharedLinksDidnTReceiveConfirmationInstructions: {
    id: 'users.shared.links.didn_t_receive_confirmation_instructions',
    defaultMessage: "Didn't receive confirmation instructions?",
  },
  usersSharedLinksDidnTReceiveUnlockInstructions: {
    id: 'users.shared.links.didn_t_receive_unlock_instructions',
    defaultMessage: "Didn't receive unlock instructions?",
  },
  usersSharedLinksForgotYourPassword: {
    id: 'users.shared.links.forgot_your_password',
    defaultMessage: 'Forgot your password?',
  },
  usersSharedLinksSignIn: {
    id: 'users.shared.links.sign_in',
    defaultMessage: 'Sign in',
  },
  usersSharedLinksSignInWithProvider: {
    id: 'users.shared.links.sign_in_with_provider',
    defaultMessage: 'Sign in with {provider}',
  },
  usersSharedLinksSignUp: {
    id: 'users.shared.links.sign_up',
    defaultMessage: 'Sign up',
  },
  usersUnlocksNewResendUnlockInstructions: {
    id: 'users.unlocks.new.resend_unlock_instructions',
    defaultMessage: 'Resend unlock instructions',
  },
  usersUnlocksSendInstructions: {
    id: 'users.unlocks.send_instructions',
    defaultMessage:
      'You will receive an email with instructions for how to unlock your account in a few minutes.',
  },
  usersUnlocksSendParanoidInstructions: {
    id: 'users.unlocks.send_paranoid_instructions',
    defaultMessage:
      'If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.',
  },
  usersUnlocksUnlocked: {
    id: 'users.unlocks.unlocked',
    defaultMessage:
      'Your account has been unlocked successfully. Please sign in to continue.',
  },
  errorsMessagesAlreadyConfirmed: {
    id: 'errors.messages.already_confirmed',
    defaultMessage: 'was already confirmed, please try signing in',
  },
  errorsMessagesConfirmationPeriodExpired: {
    id: 'errors.messages.confirmation_period_expired',
    defaultMessage:
      'needs to be confirmed within {period}, please request a new one',
  },
  errorsMessagesExpired: {
    id: 'errors.messages.expired',
    defaultMessage: 'has expired, please request a new one',
  },
  errorsMessagesNotFound: {
    id: 'errors.messages.not_found',
    defaultMessage: 'not found',
  },
  errorsMessagesNotLocked: {
    id: 'errors.messages.not_locked',
    defaultMessage: 'was not locked',
  },
  errorsMessagesNotSavedOne: {
    id: 'errors.messages.not_saved.one',
    defaultMessage: '1 error prohibited this {resource} from being saved:',
  },
  errorsMessagesNotSavedOther: {
    id: 'errors.messages.not_saved.other',
    defaultMessage:
      '{count} errors prohibited this {resource} from being saved:',
  },
  activerecordAttributesBuilderArmyListSizeWarbands: {
    id: 'activerecord.attributes.builder.army_list.size.Warbands',
    defaultMessage: 'Warbands',
  },
  activerecordAttributesBuilderArmyListSizeStandard: {
    id: 'activerecord.attributes.builder.army_list.size.Standard',
    defaultMessage: 'Standard',
  },
  activerecordAttributesBuilderArmyListSizeGrandarmies: {
    id: 'activerecord.attributes.builder.army_list.size.GrandArmies',
    defaultMessage: 'Grand Armies',
  },
  'activerecordAttributesDataAnalytics::ReportDeploymentsCounterthrust': {
    id: 'activerecord.attributes.data_analytics/report.deployments.CounterThrust',
    defaultMessage: 'Counter Thrust',
  },
  'activerecordAttributesDataAnalytics::ReportDeploymentsDawnassult': {
    id: 'activerecord.attributes.data_analytics/report.deployments.DawnAssult',
    defaultMessage: 'Dawn Assult',
  },
  'activerecordAttributesDataAnalytics::ReportDeploymentsEncircle': {
    id: 'activerecord.attributes.data_analytics/report.deployments.Encircle',
    defaultMessage: 'Encircle',
  },
  'activerecordAttributesDataAnalytics::ReportDeploymentsFrontlineclash': {
    id: 'activerecord.attributes.data_analytics/report.deployments.FrontlineClash',
    defaultMessage: 'Frontline Clash',
  },
  'activerecordAttributesDataAnalytics::ReportDeploymentsMarchingcolumns': {
    id: 'activerecord.attributes.data_analytics/report.deployments.MarchingColumns',
    defaultMessage: 'Marching Columns',
  },
  'activerecordAttributesDataAnalytics::ReportDeploymentsRefusedflank': {
    id: 'activerecord.attributes.data_analytics/report.deployments.RefusedFlank',
    defaultMessage: 'Refused Flank',
  },
  'activerecordAttributesDataAnalytics::ReportMapsA1': {
    id: 'activerecord.attributes.data_analytics/report.maps.A1',
    defaultMessage: 'A1 - Shrouded Pool',
  },
  'activerecordAttributesDataAnalytics::ReportMapsA2': {
    id: 'activerecord.attributes.data_analytics/report.maps.A2',
    defaultMessage: 'A2 - Foothill Outpost',
  },
  'activerecordAttributesDataAnalytics::ReportMapsA3': {
    id: 'activerecord.attributes.data_analytics/report.maps.A3',
    defaultMessage: 'A3 - Dilapidated Manor',
  },
  'activerecordAttributesDataAnalytics::ReportMapsA4': {
    id: 'activerecord.attributes.data_analytics/report.maps.A4',
    defaultMessage: 'A4 - Volcanic Lake',
  },
  'activerecordAttributesDataAnalytics::ReportMapsA5': {
    id: 'activerecord.attributes.data_analytics/report.maps.A5',
    defaultMessage: 'A5 - Misty Marshes',
  },
  'activerecordAttributesDataAnalytics::ReportMapsA6': {
    id: 'activerecord.attributes.data_analytics/report.maps.A6',
    defaultMessage: 'A6 - Ancient Walls',
  },
  'activerecordAttributesDataAnalytics::ReportMapsA7': {
    id: 'activerecord.attributes.data_analytics/report.maps.A7',
    defaultMessage: 'A7 - Beacon Hill',
  },
  'activerecordAttributesDataAnalytics::ReportMapsA8': {
    id: 'activerecord.attributes.data_analytics/report.maps.A8',
    defaultMessage: 'A8 - Witch’s Cottage',
  },
  'activerecordAttributesDataAnalytics::ReportMapsB1': {
    id: 'activerecord.attributes.data_analytics/report.maps.B1',
    defaultMessage: 'B1 - Mage’s Sanctum',
  },
  'activerecordAttributesDataAnalytics::ReportMapsB2': {
    id: 'activerecord.attributes.data_analytics/report.maps.B2',
    defaultMessage: 'B2 - Villa Grounds',
  },
  'activerecordAttributesDataAnalytics::ReportMapsB3': {
    id: 'activerecord.attributes.data_analytics/report.maps.B3',
    defaultMessage: 'B3 - Ancient Fortress',
  },
  'activerecordAttributesDataAnalytics::ReportMapsB4': {
    id: 'activerecord.attributes.data_analytics/report.maps.B4',
    defaultMessage: 'B4 - Frontier Farm',
  },
  'activerecordAttributesDataAnalytics::ReportMapsB5': {
    id: 'activerecord.attributes.data_analytics/report.maps.B5',
    defaultMessage: 'B5 - Ravaged Watchtower',
  },
  'activerecordAttributesDataAnalytics::ReportMapsB6': {
    id: 'activerecord.attributes.data_analytics/report.maps.B6',
    defaultMessage: 'B6 - Creeping Forest',
  },
  'activerecordAttributesDataAnalytics::ReportMapsB7': {
    id: 'activerecord.attributes.data_analytics/report.maps.B7',
    defaultMessage: 'B7 - Eerie Graveyard',
  },
  'activerecordAttributesDataAnalytics::ReportMapsB8': {
    id: 'activerecord.attributes.data_analytics/report.maps.B8',
    defaultMessage: 'B8 - Shattered Bridge',
  },
  'activerecordAttributesDataAnalytics::ReportObjectivesBreakthrough': {
    id: 'activerecord.attributes.data_analytics/report.objectives.Breakthrough',
    defaultMessage: 'Breakthrough',
  },
  'activerecordAttributesDataAnalytics::ReportObjectivesCaptureflags': {
    id: 'activerecord.attributes.data_analytics/report.objectives.CaptureFlags',
    defaultMessage: 'Capture the Flags',
  },
  'activerecordAttributesDataAnalytics::ReportObjectivesHoldground': {
    id: 'activerecord.attributes.data_analytics/report.objectives.HoldGround',
    defaultMessage: 'Hold the Ground',
  },
  'activerecordAttributesDataAnalytics::ReportObjectivesKinghill': {
    id: 'activerecord.attributes.data_analytics/report.objectives.KingHill',
    defaultMessage: 'King of the Hill',
  },
  'activerecordAttributesDataAnalytics::ReportObjectivesSecuretarget': {
    id: 'activerecord.attributes.data_analytics/report.objectives.SecureTarget',
    defaultMessage: 'Secure Target',
  },
  'activerecordAttributesDataAnalytics::ReportObjectivesSpoilswar': {
    id: 'activerecord.attributes.data_analytics/report.objectives.SpoilsWar',
    defaultMessage: 'Spoils of War',
  },
  'activerecordAttributesDataAnalytics::ReportOpponentDeployment': {
    id: 'activerecord.attributes.data_analytics/report.opponent_deployment',
    defaultMessage: 'First to deploy',
  },
  'activerecordAttributesDataAnalytics::ReportOpponentFirstTurn': {
    id: 'activerecord.attributes.data_analytics/report.opponent_first_turn',
    defaultMessage: 'First turn',
  },
  'activerecordAttributesDataAnalytics::ReportOpponentObjective': {
    id: 'activerecord.attributes.data_analytics/report.opponent_objective',
    defaultMessage: 'Take the objective',
  },
  'activerecordAttributesDataAnalytics::ReportYourDeployment': {
    id: 'activerecord.attributes.data_analytics/report.your_deployment',
    defaultMessage: 'First to deploy',
  },
  'activerecordAttributesDataAnalytics::ReportYourFirstTurn': {
    id: 'activerecord.attributes.data_analytics/report.your_first_turn',
    defaultMessage: 'First turn',
  },
  'activerecordAttributesDataAnalytics::ReportYourObjective': {
    id: 'activerecord.attributes.data_analytics/report.your_objective',
    defaultMessage: 'Take the objective',
  },
  'activerecordAttributesNinthAge::MagicItemOnlyFoot': {
    id: 'activerecord.attributes.ninth_age/magic_item.only_foot',
    defaultMessage: 'Prohibited mount',
  },
  'activerecordAttributesNinthAge::MagicItemOnlyWizard': {
    id: 'activerecord.attributes.ninth_age/magic_item.only_wizard',
    defaultMessage: 'Only wizard can use it',
  },
  'activerecordAttributesNinthAge::MagicItemOrganisationIds': {
    id: 'activerecord.attributes.ninth_age/magic_item.organisation_ids',
    defaultMessage: 'Organisations required from the model',
  },
  'activerecordAttributesNinthAge::MagicItemModelRuleIds': {
    id: 'activerecord.attributes.ninth_age/magic_item.model_rule_ids',
    defaultMessage: 'Prohibited  model rules on model',
  },
  'activerecordAttributesNinthAge::MagicItemUnitIds': {
    id: 'activerecord.attributes.ninth_age/magic_item.unit_ids',
    defaultMessage: 'For this units only',
  },
  'activerecordAttributesNinthAge::MagicItemUnitSize': {
    id: 'activerecord.attributes.ninth_age/magic_item.unit_size',
    defaultMessage: 'Unit with this size can not use this item',
  },
  'activerecordAttributesNinthAge::MagicStandardOrganisation': {
    id: 'activerecord.attributes.ninth_age/magic_standard.organisation',
    defaultMessage: 'Add organisation to unit',
  },
  'activerecordAttributesNinthAge::MagicStandardOrganisationIds': {
    id: 'activerecord.attributes.ninth_age/magic_standard.organisation_ids',
    defaultMessage: "Only organisation's units",
  },
  'activerecordAttributesNinthAge::TroopCaracAgi': {
    id: 'activerecord.attributes.ninth_age/troop.carac_agi',
    defaultMessage: 'Agi',
  },
  'activerecordAttributesNinthAge::TroopCaracAp': {
    id: 'activerecord.attributes.ninth_age/troop.carac_ap',
    defaultMessage: 'Ap',
  },
  'activerecordAttributesNinthAge::TroopCaracAtt': {
    id: 'activerecord.attributes.ninth_age/troop.carac_att',
    defaultMessage: 'Att',
  },
  'activerecordAttributesNinthAge::TroopCaracOf': {
    id: 'activerecord.attributes.ninth_age/troop.carac_of',
    defaultMessage: 'Off',
  },
  'activerecordAttributesNinthAge::TroopCaracStr': {
    id: 'activerecord.attributes.ninth_age/troop.carac_str',
    defaultMessage: 'Str',
  },
  'activerecordAttributesNinthAge::UnitCaracCha': {
    id: 'activerecord.attributes.ninth_age/unit.carac_cha',
    defaultMessage: 'Cha',
  },
  'activerecordAttributesNinthAge::UnitCaracMob': {
    id: 'activerecord.attributes.ninth_age/unit.carac_mob',
    defaultMessage: 'Mob',
  },
  'activerecordAttributesNinthAge::UnitCaracCou': {
    id: 'activerecord.attributes.ninth_age/unit.carac_cou',
    defaultMessage: 'Cou',
  },
  'activerecordAttributesNinthAge::UnitCaracAeg': {
    id: 'activerecord.attributes.ninth_age/unit.carac_aeg',
    defaultMessage: 'Aeg',
  },
  'activerecordAttributesNinthAge::UnitCaracArm': {
    id: 'activerecord.attributes.ninth_age/unit.carac_arm',
    defaultMessage: 'Arm',
  },
  'activerecordAttributesNinthAge::UnitCaracDef': {
    id: 'activerecord.attributes.ninth_age/unit.carac_def',
    defaultMessage: 'Def',
  },
  'activerecordAttributesNinthAge::UnitCaracDis': {
    id: 'activerecord.attributes.ninth_age/unit.carac_dis',
    defaultMessage: 'Dis',
  },
  'activerecordAttributesNinthAge::UnitCaracEvoked': {
    id: 'activerecord.attributes.ninth_age/unit.carac_evoked',
    defaultMessage: 'Rea',
  },
  'activerecordAttributesNinthAge::UnitCaracFlyAdv': {
    id: 'activerecord.attributes.ninth_age/unit.carac_fly_adv',
    defaultMessage: 'Fly adv',
  },
  'activerecordAttributesNinthAge::UnitCaracFlyMar': {
    id: 'activerecord.attributes.ninth_age/unit.carac_fly_mar',
    defaultMessage: 'Fly mar',
  },
  'activerecordAttributesNinthAge::UnitCaracGroundAdv': {
    id: 'activerecord.attributes.ninth_age/unit.carac_ground_adv',
    defaultMessage: 'Adv',
  },
  'activerecordAttributesNinthAge::UnitCaracGroundMar': {
    id: 'activerecord.attributes.ninth_age/unit.carac_ground_mar',
    defaultMessage: 'Mar',
  },
  'activerecordAttributesNinthAge::UnitCaracHp': {
    id: 'activerecord.attributes.ninth_age/unit.carac_hp',
    defaultMessage: 'HP',
  },
  'activerecordAttributesNinthAge::UnitCaracRes': {
    id: 'activerecord.attributes.ninth_age/unit.carac_res',
    defaultMessage: 'Res',
  },
  'activerecordAttributesNinthAge::UnitBaseOne': {
    id: 'activerecord.attributes.ninth_age/unit.base.one',
    defaultMessage: 'Base',
  },
  'activerecordAttributesNinthAge::UnitBaseHundredhundredfifty': {
    id: 'activerecord.attributes.ninth_age/unit.base.HundredHundredFifty',
    defaultMessage: '100x150',
  },
  'activerecordAttributesNinthAge::UnitBaseEightyeighty': {
    id: 'activerecord.attributes.ninth_age/unit.base.EightyEighty',
    defaultMessage: '80x80',
  },
  'activerecordAttributesNinthAge::UnitBaseFiftyfifty': {
    id: 'activerecord.attributes.ninth_age/unit.base.FiftyFifty',
    defaultMessage: '50x50',
  },
  'activerecordAttributesNinthAge::UnitBaseFiftyhundred': {
    id: 'activerecord.attributes.ninth_age/unit.base.FiftyHundred',
    defaultMessage: '50x100',
  },
  'activerecordAttributesNinthAge::UnitBaseFiftyseventyfive': {
    id: 'activerecord.attributes.ninth_age/unit.base.FiftySeventyFive',
    defaultMessage: '50x75',
  },
  'activerecordAttributesNinthAge::UnitBaseFortyforty': {
    id: 'activerecord.attributes.ninth_age/unit.base.FortyForty',
    defaultMessage: '40x40',
  },
  'activerecordAttributesNinthAge::UnitBaseFortyround': {
    id: 'activerecord.attributes.ninth_age/unit.base.FortyRound',
    defaultMessage: '40',
  },
  'activerecordAttributesNinthAge::UnitBaseFortysixty': {
    id: 'activerecord.attributes.ninth_age/unit.base.FortySixty',
    defaultMessage: '40x60',
  },
  'activerecordAttributesNinthAge::UnitBaseFortytwenty': {
    id: 'activerecord.attributes.ninth_age/unit.base.FortyTwenty',
    defaultMessage: '40x20',
  },
  'activerecordAttributesNinthAge::UnitBaseHundredfifty': {
    id: 'activerecord.attributes.ninth_age/unit.base.HundredFifty',
    defaultMessage: '100x50',
  },
  'activerecordAttributesNinthAge::UnitBaseHundredfiftyhundred': {
    id: 'activerecord.attributes.ninth_age/unit.base.HundredFiftyHundred',
    defaultMessage: '150x100',
  },
  'activerecordAttributesNinthAge::UnitBaseHundredhundred': {
    id: 'activerecord.attributes.ninth_age/unit.base.HundredHundred',
    defaultMessage: '100x100',
  },
  'activerecordAttributesNinthAge::UnitBaseSeventyfivefifty': {
    id: 'activerecord.attributes.ninth_age/unit.base.SeventyFiveFifty',
    defaultMessage: '75x50',
  },
  'activerecordAttributesNinthAge::UnitBaseSeventyfivehundred': {
    id: 'activerecord.attributes.ninth_age/unit.base.SeventyFiveHundred',
    defaultMessage: '75x100',
  },
  'activerecordAttributesNinthAge::UnitBaseSeventyfiveround': {
    id: 'activerecord.attributes.ninth_age/unit.base.SeventyFiveRound',
    defaultMessage: '75',
  },
  'activerecordAttributesNinthAge::UnitBaseSixtyhundred': {
    id: 'activerecord.attributes.ninth_age/unit.base.SixtyHundred',
    defaultMessage: '60x100',
  },
  'activerecordAttributesNinthAge::UnitBaseSixtyround': {
    id: 'activerecord.attributes.ninth_age/unit.base.SixtyRound',
    defaultMessage: '60',
  },
  'activerecordAttributesNinthAge::UnitBaseTwentyfivefifty': {
    id: 'activerecord.attributes.ninth_age/unit.base.TwentyFiveFifty',
    defaultMessage: '25x50',
  },
  'activerecordAttributesNinthAge::UnitBaseTwentyround': {
    id: 'activerecord.attributes.ninth_age/unit.base.TwentyRound',
    defaultMessage: '20',
  },
  'activerecordAttributesNinthAge::UnitBaseTwentyfiveround': {
    id: 'activerecord.attributes.ninth_age/unit.base.TwentyFiveRound',
    defaultMessage: '25',
  },
  'activerecordAttributesNinthAge::UnitBaseTwentyfivetwentyfive': {
    id: 'activerecord.attributes.ninth_age/unit.base.TwentyFiveTwentyFive',
    defaultMessage: '25x25',
  },
  'activerecordAttributesNinthAge::UnitBaseTwentytwenty': {
    id: 'activerecord.attributes.ninth_age/unit.base.TwentyTwenty',
    defaultMessage: '20x20',
  },
  'activerecordAttributesNinthAge::UnitBaseSeventyfiveseventyfive': {
    id: 'activerecord.attributes.ninth_age/unit.base.SeventyFiveSeventyFive',
    defaultMessage: '75x75',
  },
  'activerecordAttributesNinthAge::UnitBaseHundredtwohundred': {
    id: 'activerecord.attributes.ninth_age/unit.base.HundredTwoHundred',
    defaultMessage: '100x200',
  },
  'activerecordAttributesNinthAge::UnitBaseThirtythirty': {
    id: 'activerecord.attributes.ninth_age/unit.base.ThirtyThirty',
    defaultMessage: '30x30',
  },
  'activerecordAttributesNinthAge::UnitBaseThirtysixty': {
    id: 'activerecord.attributes.ninth_age/unit.base.ThirtySixty',
    defaultMessage: '30x60',
  },
  'activerecordAttributesNinthAge::UnitBaseFortyeighty': {
    id: 'activerecord.attributes.ninth_age/unit.base.FortyEighty',
    defaultMessage: '40x80',
  },
  activerecordAttributesNinthAgeArmySourceFanmade: {
    id: 'activerecord.attributes.ninth_age_army.source.FanMade',
    defaultMessage: 'Fan Made',
  },
  activerecordAttributesNinthAgeArmySourceOfficial: {
    id: 'activerecord.attributes.ninth_age_army.source.Official',
    defaultMessage: 'Official',
  },
  activerecordAttributesNinthAgeArmySourceSupplement: {
    id: 'activerecord.attributes.ninth_age_army.source.Supplement',
    defaultMessage: 'Supplement',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryBsb: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.BSB',
    defaultMessage: 'Battle Standard Bearer',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryC: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.C',
    defaultMessage: 'Champion',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryEquipment: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.Equipment',
    defaultMessage: 'Equipment',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryExtraspells: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.ExtraSpells',
    defaultMessage: 'Spells',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryGeneral: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.General',
    defaultMessage: 'General',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryGeneric: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.Generic',
    defaultMessage: 'Generic',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryM: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.M',
    defaultMessage: 'Musician',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMagicbanner: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.MagicBanner',
    defaultMessage: 'Banner Enchantment',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMagicequipment: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.MagicEquipment',
    defaultMessage: 'Magic items',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMagiclvl: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.MagicLvl',
    defaultMessage: 'Magic LVL',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMagicpath: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.MagicPath',
    defaultMessage: 'Magic Path',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMaytake: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.MayTake',
    defaultMessage: 'May take',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMount: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.Mount',
    defaultMessage: 'Mount',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMustchoice: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.MustChoice',
    defaultMessage: 'Must choose',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryOnechoice: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.OneChoice',
    defaultMessage: 'One choice only',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryS: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.S',
    defaultMessage: 'Standard Bearer',
  },
  activerecordAttributesNinthAgeUnitOptionCategorySpecialrule: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.SpecialRule',
    defaultMessage: 'Special Rule',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryWizardadept: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.WizardAdept',
    defaultMessage: 'Wizard Adept',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryWizardapprentice: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.WizardApprentice',
    defaultMessage: 'Wizard Apprentice',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryWizardmaster: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.WizardMaster',
    defaultMessage: 'Wizard Master',
  },
  activerecordAttributesNinthAgeUnitOptionCategorySpell: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.Spell',
    defaultMessage: 'Spell',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMagicitemcategory: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.MagicItemCategory',
    defaultMessage: 'Magic Item Category',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMagicitem: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.MagicItem',
    defaultMessage: 'Magic Item',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryMagicstandard: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.MagicStandard',
    defaultMessage: 'Magic Standard',
  },
  activerecordAttributesNinthAgeUnitOptionCategoryUnitequipment: {
    id: 'activerecord.attributes.ninth_age_unit_option.category.UnitEquipment',
    defaultMessage: 'Unit Equipment',
  },
  activerecordAttributesNinthAgeUnitOptionOrganisationModeChangeunitorganisation:
    {
      id: 'activerecord.attributes.ninth_age_unit_option.organisation_mode.ChangeUnitOrganisation',
      defaultMessage: "Change unit's organisation",
    },
  activerecordAttributesNinthAgeUnitOptionOrganisationModeExcludeaddorganisation:
    {
      id: 'activerecord.attributes.ninth_age_unit_option.organisation_mode.ExcludeAddOrganisation',
      defaultMessage: "Not affected with other unit option's organisation",
    },
  activerecordAttributesNinthAgeUnitOptionOrganisationModeUnit: {
    id: 'activerecord.attributes.ninth_age_unit_option.organisation_mode.Unit',
    defaultMessage: 'All the unit',
  },
  activerecordAttributesNinthAgeUnitOptionAvailabilityActionDisable: {
    id: 'activerecord.attributes.ninth_age_unit_option_availability.action.Disable',
    defaultMessage: 'Disable',
  },
  activerecordAttributesNinthAgeUnitOptionAvailabilityActionDisableforall: {
    id: 'activerecord.attributes.ninth_age_unit_option_availability.action.DisableForAll',
    defaultMessage: 'Disable for all units if present',
  },
  activerecordAttributesNinthAgeUnitOptionAvailabilityActionEnable: {
    id: 'activerecord.attributes.ninth_age_unit_option_availability.action.Enable',
    defaultMessage: 'Enable',
  },
  activerecordAttributesNinthAgeUnitOptionAvailabilityActionChangepoints: {
    id: 'activerecord.attributes.ninth_age_unit_option_availability.action.ChangePoints',
    defaultMessage: 'Change the cost of other option',
  },
  activerecordAttributesNinthAgeUnitOptionAvailabilityActionAutoselect: {
    id: 'activerecord.attributes.ninth_age_unit_option_availability.action.AutoSelect',
    defaultMessage: 'Auto select another option',
  },
  activerecordAttributesNinthAgeUnitOptionAvailabilityActionChangechoiselimit: {
    id: 'activerecord.attributes.ninth_age_unit_option_availability.action.ChangeChoiseLimit',
    defaultMessage: 'Change the limit choise of an option',
  },
  activerecordAttributesNinthAgeUnitOptionChangeModelRuleActionDisable: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Disable',
    defaultMessage: 'Disable',
  },
  activerecordAttributesNinthAgeUnitOptionChangeModelRuleActionEnable: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_model_rule.action.Enable',
    defaultMessage: 'Enable',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilActionAdd: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.action.Add',
    defaultMessage: 'Add',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilActionReplace: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.action.Replace',
    defaultMessage: 'Replace',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsA: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.A',
    defaultMessage: 'V1-A',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsBs: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.BS',
    defaultMessage: 'V1-BS',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsE: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.E',
    defaultMessage: 'V1-E',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsI: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.I',
    defaultMessage: 'V1-I',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsLd: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.LD',
    defaultMessage: 'V1-Ld',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsM: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.M',
    defaultMessage: 'V1-M',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsS: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.S',
    defaultMessage: 'V1-S',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsT: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.T',
    defaultMessage: 'V1-T',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsW: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.W',
    defaultMessage: 'V1-W',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsWs: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.WS',
    defaultMessage: 'V1-WS',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracAeg: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_aeg',
    defaultMessage: 'V2-Aeg',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracAgi: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_agi',
    defaultMessage: 'V2-Agi',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracAp: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ap',
    defaultMessage: 'V2-Ap',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracArm: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_arm',
    defaultMessage: 'V2-Arm',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracAtt: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_att',
    defaultMessage: 'V2-Att',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracDef: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_def',
    defaultMessage: 'V2-Def',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracDis: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_dis',
    defaultMessage: 'V2-Dis',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracEvoked: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_evoked',
    defaultMessage: 'V2-Evoked',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracFlyAdv: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_adv',
    defaultMessage: 'V2-Fly-Adv',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracFlyMar: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_fly_mar',
    defaultMessage: 'V2-Fly-Mar',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracGroundAdv: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_adv',
    defaultMessage: 'V2-Adv',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracGroundMar: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_ground_mar',
    defaultMessage: 'V2-Mar',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracHp: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_hp',
    defaultMessage: 'V2-Hp',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracOf: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_of',
    defaultMessage: 'V2-Of',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracRes: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_res',
    defaultMessage: 'V2-Res',
  },
  activerecordAttributesNinthAgeUnitOptionChangeProfilCaracsCaracStr: {
    id: 'activerecord.attributes.ninth_age_unit_option_change_profil.caracs.carac_str',
    defaultMessage: 'V2-Str',
  },
  activerecordAttributesNinthAgeUnitOptionLimitLimitItembyarmy: {
    id: 'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByArmy',
    defaultMessage: 'per Army',
  },
  activerecordAttributesNinthAgeUnitOptionLimitLimitItembymodel: {
    id: 'activerecord.attributes.ninth_age_unit_option_limit.limit.ItemByModel',
    defaultMessage: 'item per Unit',
  },
  activerecordAttributesNinthAgeUnitOptionLimitLimitMaxratiobyarmy: {
    id: 'activerecord.attributes.ninth_age_unit_option_limit.limit.MaxRatioByArmy',
    defaultMessage: 'Max Ratio per Army',
  },
  activerecordAttributesNinthAgeUnitOptionLimitLimitModel: {
    id: 'activerecord.attributes.ninth_age_unit_option_limit.limit.Model',
    defaultMessage: 'Models per Army',
  },
  activerecordAttributesNinthAgeUnitOptionLimitLimitModelbyunit: {
    id: 'activerecord.attributes.ninth_age_unit_option_limit.limit.ModelByUnit',
    defaultMessage: 'Models per Unit',
  },
  activerecordAttributesNinthAgeUnitOptionLimitLimitUnits: {
    id: 'activerecord.attributes.ninth_age_unit_option_limit.limit.Units',
    defaultMessage: 'Units per Army',
  },
  activerecordAttributesNinthAgeUnitOptionLimitSelectorModelQuantity: {
    id: 'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Quantity',
    defaultMessage: 'Quantity from the option',
  },
  activerecordAttributesNinthAgeUnitOptionLimitSelectorModelSelection: {
    id: 'activerecord.attributes.ninth_age_unit_option_limit.selector_model.Selection',
    defaultMessage: 'Option selected',
  },
  activerecordAttributesNinthAgeVersionGameEssenceofwar: {
    id: 'activerecord.attributes.ninth_age_version.game.essenceOfWar',
    defaultMessage: 'Essence of War',
  },
  activerecordAttributesNinthAgeVersionGameWarhammerbattle: {
    id: 'activerecord.attributes.ninth_age_version.game.WarhammerBattle',
    defaultMessage: 'Warhammer Battle',
  },
  activerecordAttributesNinthAgeVersionGameTheoldworld: {
    id: 'activerecord.attributes.ninth_age_version.game.theOldWorld',
    defaultMessage: 'The Old World',
  },
  activerecordAttributesNinthAgeVersionGameNinthage: {
    id: 'activerecord.attributes.ninth_age_version.game.ninthAge',
    defaultMessage: 'Ninth Age',
  },
  activerecordAttributesNinthAgeVersionGameBattle: {
    id: 'activerecord.attributes.ninth_age_version.game.battle',
    defaultMessage: 'Warhammer Battle',
  },
  'activerecordAttributesTournament::ContestParticipation': {
    id: 'activerecord.attributes.tournament/contest.participation',
    defaultMessage: 'Participation',
  },
  activerecordAttributesUserGameOne: {
    id: 'activerecord.attributes.user.game.one',
    defaultMessage: 'Game',
  },
  activerecordAttributesUserGameEssenceofwar: {
    id: 'activerecord.attributes.user.game.essenceOfWar',
    defaultMessage: 'Essence of War',
  },
  activerecordAttributesUserGameNinthage: {
    id: 'activerecord.attributes.user.game.ninthAge',
    defaultMessage: 'Ninth Age',
  },
  activerecordAttributesUserGameBattle: {
    id: 'activerecord.attributes.user.game.battle',
    defaultMessage: 'Warhammer Battle',
  },
  activerecordAttributesUserBuilderInterfaceClassic: {
    id: 'activerecord.attributes.user.builder_interface.classic',
    defaultMessage: 'Classic',
  },
  activerecordAttributesUserBuilderInterfaceOldskool: {
    id: 'activerecord.attributes.user.builder_interface.oldSkool',
    defaultMessage: 'Old Skool (wahb)',
  },
  activerecordAttributesPublicationLatexBuildStatusOne: {
    id: 'activerecord.attributes.publication_latex_build.status.one',
    defaultMessage: 'Status',
  },
  activerecordAttributesPublicationLatexBuildStatusOther: {
    id: 'activerecord.attributes.publication_latex_build.status.other',
    defaultMessage: 'Status',
  },
  activerecordAttributesPublicationLatexBuildStatusPending: {
    id: 'activerecord.attributes.publication_latex_build.status.pending',
    defaultMessage: 'Pending',
  },
  activerecordAttributesPublicationLatexBuildStatusSuccess: {
    id: 'activerecord.attributes.publication_latex_build.status.success',
    defaultMessage: 'Success',
  },
  activerecordAttributesPublicationLatexBuildStatusFailed: {
    id: 'activerecord.attributes.publication_latex_build.status.failed',
    defaultMessage: 'Failed',
  },
  'activerecordModelsNinthAge::MagicStandardOne': {
    id: 'activerecord.models.ninth_age/magic_standard.one',
    defaultMessage: 'Magic banner',
  },
  'activerecordModelsNinthAge::MagicStandardOther': {
    id: 'activerecord.models.ninth_age/magic_standard.other',
    defaultMessage: 'Magic banners',
  },
  'activerecordModelsNinthAge::UnitOne': {
    id: 'activerecord.models.ninth_age/unit.one',
    defaultMessage: 'Unit',
  },
  'activerecordModelsNinthAge::UnitOther': {
    id: 'activerecord.models.ninth_age/unit.other',
    defaultMessage: 'Units',
  },
  adminDashboard: { id: 'admin.dashboard', defaultMessage: 'Administration' },
  adminTournament: { id: 'admin.tournament', defaultMessage: 'Tournament Org' },
  and: { id: 'and', defaultMessage: ' and ' },
  armyArmybook: { id: 'army.armybook', defaultMessage: 'Army book' },
  armyBanner: { id: 'army.banner', defaultMessage: 'Banner enchantement' },
  armyIndexShow: { id: 'army.index.show', defaultMessage: 'Show' },
  armyIndexTitle: { id: 'army.index.title', defaultMessage: 'All armies' },
  armyShowBack: { id: 'army.show.back', defaultMessage: 'Back' },
  armyListCloneFormAction: {
    id: 'army_list.clone.form.action',
    defaultMessage: 'Are you sure to duplicate list:',
  },
  armyListCloneFormTitle: {
    id: 'army_list.clone.form.title',
    defaultMessage: 'Duplicate list',
  },
  armyListDeleteFormAction: {
    id: 'army_list.delete.form.action',
    defaultMessage: 'Are you sure to destroy this list:',
  },
  armyListDeleteFormTitle: {
    id: 'army_list.delete.form.title',
    defaultMessage: 'Delete list',
  },
  armyListEditTitle: {
    id: 'army_list.edit.title',
    defaultMessage: 'Update the list',
  },
  armyListExportHtmlFull: {
    id: 'army_list.export.html_full',
    defaultMessage: 'Full HTML',
  },
  armyListExportHtmlLite: {
    id: 'army_list.export.html_lite',
    defaultMessage: 'Lite HTML',
  },
  armyListExportIncludeMagics: {
    id: 'army_list.export.include_magics',
    defaultMessage: 'Include magic paths?',
  },
  armyListExportIncludeQrcodes: {
    id: 'army_list.export.include_qrcodes',
    defaultMessage: 'Include QR codes?',
  },
  armyListExportInformation: {
    id: 'army_list.export.information',
    defaultMessage: 'Choose format for list export:',
  },
  armyListExportPdfFull: {
    id: 'army_list.export.pdf_full',
    defaultMessage: 'Full PDF',
  },
  armyListExportPdfLite: {
    id: 'army_list.export.pdf_lite',
    defaultMessage: 'Lite PDF',
  },
  armyListExportPrint: {
    id: 'army_list.export.print',
    defaultMessage: 'Print',
  },
  armyListExportSeparator: {
    id: 'army_list.export.separator',
    defaultMessage: 'Separator',
  },
  armyListExportTitle: {
    id: 'army_list.export.title',
    defaultMessage: 'Export list',
  },
  armyListExportTxtGeneral: {
    id: 'army_list.export.txt.general',
    defaultMessage: 'General',
  },
  armyListExportVerbosity: {
    id: 'army_list.export.verbosity',
    defaultMessage: 'Verbosity',
  },
  armyListFormArmyError: {
    id: 'army_list.form.army.error',
    defaultMessage: 'You must select an army.',
  },
  armyListFormArmyPlaceholder: {
    id: 'army_list.form.army.placeholder',
    defaultMessage: 'Select an army',
  },
  armyListFormArmyTitle: {
    id: 'army_list.form.army.title',
    defaultMessage: 'Army *',
  },
  armyListFormFolderPlaceholder: {
    id: 'army_list.form.folder.placeholder',
    defaultMessage: 'Select a folder',
  },
  armyListFormFolderTitle: {
    id: 'army_list.form.folder.title',
    defaultMessage: 'Folder',
  },
  armyListFormMaxName: {
    id: 'army_list.form.max.name',
    defaultMessage: 'You must choose the max of your army',
  },
  armyListFormMaxPlaceholder: {
    id: 'army_list.form.max.placeholder',
    defaultMessage: 'Enter a max',
  },
  armyListFormMaxTitle: {
    id: 'army_list.form.max.title',
    defaultMessage: 'Max *',
  },
  armyListFormMinName: {
    id: 'army_list.form.min.name',
    defaultMessage: 'You must choose the min of your army',
  },
  armyListFormMinPlaceholder: {
    id: 'army_list.form.min.placeholder',
    defaultMessage: 'Enter a min',
  },
  armyListFormMinTitle: {
    id: 'army_list.form.min.title',
    defaultMessage: 'Min *',
  },
  armyListFormNameError: {
    id: 'army_list.form.name.error',
    defaultMessage: 'You must name your list',
  },
  armyListFormNamePlaceholder: {
    id: 'army_list.form.name.placeholder',
    defaultMessage: 'Enter a name',
  },
  armyListFormNameTitle: {
    id: 'army_list.form.name.title',
    defaultMessage: 'Name *',
  },
  armyListFormNotesPlaceholder: {
    id: 'army_list.form.notes.placeholder',
    defaultMessage: 'My notes',
  },
  armyListFormNotesTitle: {
    id: 'army_list.form.notes.title',
    defaultMessage: 'Notes',
  },
  armyListFormPrivateTitle: {
    id: 'army_list.form.private.title',
    defaultMessage: 'is a private list',
  },
  armyListFormRateTitle: {
    id: 'army_list.form.rate.title',
    defaultMessage: 'Rate with max',
  },
  armyListFormVersionError: {
    id: 'army_list.form.version.error',
    defaultMessage: 'You must select a version.',
  },
  armyListFormVersionPlaceholder: {
    id: 'army_list.form.version.placeholder',
    defaultMessage: 'Select a version',
  },
  armyListFormVersionTitle: {
    id: 'army_list.form.version.title',
    defaultMessage: 'Version *',
  },
  armyListFormatTitle: {
    id: 'army_list.format.title',
    defaultMessage: 'Format \u0026 Import an army list',
  },
  armyListIndexAdd: {
    id: 'army_list.index.add',
    defaultMessage: 'Create new army list',
  },
  armyListIndexAnd: { id: 'army_list.index.and', defaultMessage: 'and' },
  armyListIndexContest: {
    id: 'army_list.index.contest',
    defaultMessage: 'Create a contest',
  },
  armyListIndexFilter: {
    id: 'army_list.index.filter',
    defaultMessage: 'Filter by',
  },
  armyListIndexFolder: {
    id: 'army_list.index.folder',
    defaultMessage: 'Create new folder',
  },
  armyListIndexNameOrNotes: {
    id: 'army_list.index.name_or_notes',
    defaultMessage: 'Name or notes',
  },
  armyListIndexSearch: {
    id: 'army_list.index.search',
    defaultMessage: 'Submit',
  },
  armyListIndexTitle: {
    id: 'army_list.index.title',
    defaultMessage: 'My army lists',
  },
  armyListNewTitle: {
    id: 'army_list.new.title',
    defaultMessage: 'Create new list',
  },
  armyListNewInfos: {
    id: 'army_list.new.infos',
    defaultMessage:
      'You can now filter armies with the last version, this can be modified in your profil',
  },
  armyListPaintFormAction: {
    id: 'army_list.paint.form.action',
    defaultMessage: 'Do you want to create it from :',
  },
  armyListPaintFormTitle: {
    id: 'army_list.paint.form.title',
    defaultMessage: 'Convert to paint list',
  },
  armyListShowBuilderInterface: {
    id: 'army_list.show.builder_interface',
    defaultMessage:
      'You can now change the default interface that you want to use directly in your profile.',
  },
  armyListShowAddUnit: {
    id: 'army_list.show.add_unit',
    defaultMessage: 'Add unit',
  },
  armyListShowDelete: { id: 'army_list.show.delete', defaultMessage: 'Delete' },
  armyListShowDuplicate: {
    id: 'army_list.show.duplicate',
    defaultMessage: 'Duplicate',
  },
  armyListShowEdit: { id: 'army_list.show.edit', defaultMessage: 'Edit' },
  armyListShowExport: { id: 'army_list.show.export', defaultMessage: 'Export' },
  armyListShowNotes: { id: 'army_list.show.notes', defaultMessage: 'Notes' },
  armyListShowOrganisationExcess: {
    id: 'army_list.show.organisation.excess',
    defaultMessage: 'Excess',
  },
  armyListShowOrganisationMissing: {
    id: 'army_list.show.organisation.missing',
    defaultMessage: 'Missing',
  },
  armyListShowOrganisationRemaining: {
    id: 'army_list.show.organisation.remaining',
    defaultMessage: 'Remaining',
  },
  armyListShowPrint: { id: 'army_list.show.print', defaultMessage: 'Print' },
  armyListShowRearrangeUnits: {
    id: 'army_list.show.rearrange_units',
    defaultMessage: 'Rearrange Units',
  },
  armyListShowTitle: {
    id: 'army_list.show.title',
    defaultMessage: 'Army list • {name}',
  },
  armyListUnitCloneFormAction: {
    id: 'army_list.unit.clone.form.action',
    defaultMessage: 'Do you want to copy:',
  },
  armyListUnitCloneFormTitle: {
    id: 'army_list.unit.clone.form.title',
    defaultMessage: 'Copy Unit',
  },
  armyListUnitDeleteFormAction: {
    id: 'army_list.unit.delete.form.action',
    defaultMessage: 'Do you want to remove:',
  },
  armyListUnitDeleteFormTitle: {
    id: 'army_list.unit.delete.form.title',
    defaultMessage: 'Delete Unit',
  },
  armyListUnitFavoriteFormAction: {
    id: 'army_list.unit.favorite.form.action',
    defaultMessage: 'Do you want to create a favorite from this unit:',
  },
  armyListUnitFavoriteFormTitle: {
    id: 'army_list.unit.favorite.form.title',
    defaultMessage: 'Create favorite',
  },
  armyListUnitFavoriteFormDescription: {
    id: 'army_list.unit.favorite.form.description',
    defaultMessage:
      'You can now create a favorite from this unit, this will be added to your favorites. When a new version of this army will be released, it will be possible to use this unit in your new lists.',
  },
  armyListUnitFormNamePlaceholder: {
    id: 'army_list.unit.form.name.placeholder',
    defaultMessage: 'Add a name',
  },
  armyListUnitFormNameTitle: {
    id: 'army_list.unit.form.name.title',
    defaultMessage: 'Name',
  },
  armyListUnitFormTitle: {
    id: 'army_list.unit.form.title',
    defaultMessage: 'Add an unit',
  },
  armyListUnitFormUnitError: {
    id: 'army_list.unit.form.unit.error',
    defaultMessage: 'You must select an unit',
  },
  armyListUnitFormUnitPlaceholder: {
    id: 'army_list.unit.form.unit.placeholder',
    defaultMessage: 'Select an unit',
  },
  armyListUnitFormUnitTitle: {
    id: 'army_list.unit.form.unit.title',
    defaultMessage: 'Unit *',
  },
  armyListUnitMagic: { id: 'army_list.unit.magic', defaultMessage: 'Magic' },
  armyListUnitNote: { id: 'army_list.unit.note', defaultMessage: 'Notes' },
  armyListUnitOptionFormBannerTitle: {
    id: 'army_list.unit.option.form.banner.title',
    defaultMessage: 'Banners',
  },
  armyListUnitOptionFormCommandTitle: {
    id: 'army_list.unit.option.form.command.title',
    defaultMessage: 'Command Group Options',
  },
  armyListUnitOptionFormEnchantementTitle: {
    id: 'army_list.unit.option.form.enchantement.title',
    defaultMessage: 'Enchant your equipment',
  },
  armyListUnitOptionFormMagicTitle: {
    id: 'army_list.unit.option.form.magic.title',
    defaultMessage: 'Magic Options',
  },
  armyListUnitOptionFormMagicItemTitle: {
    id: 'army_list.unit.option.form.magic_item.title',
    defaultMessage: 'Magic items',
  },
  armyListUnitOptionFormMountTitle: {
    id: 'army_list.unit.option.form.mount.title',
    defaultMessage: 'Mount Options',
  },
  armyListUnitOptionFormOptionTitle: {
    id: 'army_list.unit.option.form.option.title',
    defaultMessage: 'Options',
  },
  armyListUnitDeleteInformation: {
    id: 'army_list_unit.delete.information',
    defaultMessage: 'Are you sure to destroy this unit:',
  },
  armyListUnitDeleteSubmit: {
    id: 'army_list_unit.delete.submit',
    defaultMessage: '!!! Delete !!!',
  },
  armyListUnitDeleteTitle: {
    id: 'army_list_unit.delete.title',
    defaultMessage: 'Delete\u003cbr /\u003eunit',
  },
  armyListUnitDuplicateNewArmyList: {
    id: 'army_list_unit.duplicate.new_army_list',
    defaultMessage: 'New {name} list',
  },
  armyListUnitDuplicateTarget: {
    id: 'army_list_unit.duplicate.target',
    defaultMessage: 'To:',
  },
  armyListUnitDuplicateTitle: {
    id: 'army_list_unit.duplicate.title',
    defaultMessage: 'Duplicate',
  },
  armyListUnitEditFormMagic: {
    id: 'army_list_unit.edit.form.magic',
    defaultMessage: 'Magic',
  },
  armyListUnitEditFormNotes: {
    id: 'army_list_unit.edit.form.notes',
    defaultMessage: 'Notes',
  },
  armyListUnitEditMagicItems: {
    id: 'army_list_unit.edit.magic_items',
    defaultMessage: 'Magic items',
  },
  armyListUnitEditMagicStandards: {
    id: 'army_list_unit.edit.magic_standards',
    defaultMessage: 'Magic banners',
  },
  armyListUnitEditOptions: {
    id: 'army_list_unit.edit.options',
    defaultMessage: 'Options',
  },
  armyListUnitEditTitle: {
    id: 'army_list_unit.edit.title',
    defaultMessage: 'Edit',
  },
  armyListUnitFormName: {
    id: 'army_list_unit.form.name',
    defaultMessage: 'Name',
  },
  armyListUnitFormSubmit: {
    id: 'army_list_unit.form.submit',
    defaultMessage: 'Create Unit',
  },
  armyListUnitNewTitle: {
    id: 'army_list_unit.new.title',
    defaultMessage: 'Add new unit',
  },
  armyListUnitShowCommandGroupUnitOptions: {
    id: 'army_list_unit.show.command_group_unit_options',
    defaultMessage: 'Command Group Options',
  },
  armyListUnitShowDelete: {
    id: 'army_list_unit.show.delete',
    defaultMessage: 'Delete',
  },
  armyListUnitShowDuplicate: {
    id: 'army_list_unit.show.duplicate',
    defaultMessage: 'Duplicate',
  },
  armyListUnitShowEdit: {
    id: 'army_list_unit.show.edit',
    defaultMessage: 'Edit',
  },
  armyListUnitShowModelRules: {
    id: 'army_list_unit.show.model_rules',
    defaultMessage: 'Model Rules',
  },
  armyListUnitShowMagic: {
    id: 'army_list_unit.show.magic',
    defaultMessage: 'Magic',
  },
  armyListUnitShowMagicItems: {
    id: 'army_list_unit.show.magic_items',
    defaultMessage: 'Magic items',
  },
  armyListUnitShowMagicLvlUnitOptions: {
    id: 'army_list_unit.show.magic_lvl_unit_options',
    defaultMessage: 'May become (one choice only)',
  },
  armyListUnitShowMagicStandards: {
    id: 'army_list_unit.show.magic_standards',
    defaultMessage: 'Magic banners',
  },
  armyListUnitShowEquipmentOptions: {
    id: 'army_list_unit.show.equipment_options',
    defaultMessage: 'Enchantment Options',
  },
  armyListUnitShowMagicItemOptions: {
    id: 'army_list_unit.show.magic_item_options',
    defaultMessage: 'Magic items',
  },
  armyListUnitShowMagicUnitOptions: {
    id: 'army_list_unit.show.magic_unit_options',
    defaultMessage: 'Magic Options',
  },
  armyListUnitShowMountUnitOptions: {
    id: 'army_list_unit.show.mount_unit_options',
    defaultMessage: 'Mount Options',
  },
  armyListUnitShowNotes: {
    id: 'army_list_unit.show.notes',
    defaultMessage: 'Notes',
  },
  armyListUnitShowPathUnitOptions: {
    id: 'army_list_unit.show.path_unit_options',
    defaultMessage: 'Must generate spells from',
  },
  armyListUnitShowPathUnitOptionsChooseOne: {
    id: 'army_list_unit.show.path_unit_options_choose_one',
    defaultMessage: 'Must generate spells from (choose one)',
  },
  armyListUnitShowQrcodeTitle: {
    id: 'army_list_unit.show.qrcode.title',
    defaultMessage: 'Qr codes of your army',
  },
  armyListUnitShowQrcodeDescription: {
    id: 'army_list_unit.show.qrcode.description',
    defaultMessage:
      "Your can print this page to have all your army's units qrcode and cut them to stick them on your units, with them you can directly access to the unit's profil with your phone.",
  },
  armyListUnitShowTroopsA: {
    id: 'army_list_unit.show.troops.A',
    defaultMessage: 'A',
  },
  armyListUnitShowTroopsBs: {
    id: 'army_list_unit.show.troops.BS',
    defaultMessage: 'BS',
  },
  armyListUnitShowTroopsE: {
    id: 'army_list_unit.show.troops.E',
    defaultMessage: 'Evoked',
  },
  armyListUnitShowTroopsI: {
    id: 'army_list_unit.show.troops.I',
    defaultMessage: 'I',
  },
  armyListUnitShowTroopsLd: {
    id: 'army_list_unit.show.troops.LD',
    defaultMessage: 'Ld',
  },
  armyListUnitShowTroopsM: {
    id: 'army_list_unit.show.troops.M',
    defaultMessage: 'M',
  },
  armyListUnitShowTroopsS: {
    id: 'army_list_unit.show.troops.S',
    defaultMessage: 'S',
  },
  armyListUnitShowTroopsT: {
    id: 'army_list_unit.show.troops.T',
    defaultMessage: 'T',
  },
  armyListUnitShowTroopsW: {
    id: 'army_list_unit.show.troops.W',
    defaultMessage: 'W',
  },
  armyListUnitShowTroopsWs: {
    id: 'army_list_unit.show.troops.WS',
    defaultMessage: 'WS',
  },
  armyListUnitShowTroopsName: {
    id: 'army_list_unit.show.troops.name',
    defaultMessage: 'Troops',
  },
  armyListUnitShowTroopsProfile: {
    id: 'army_list_unit.show.troops.profile',
    defaultMessage: 'Profile',
  },
  armyListUnitShowTroopsType: {
    id: 'army_list_unit.show.troops.type',
    defaultMessage: "Troop's type",
  },
  armyListUnitShowUnitOptions: {
    id: 'army_list_unit.show.unit_options',
    defaultMessage: 'Options',
  },
  armyMagicSpellName: {
    id: 'army_magic_spell.name',
    defaultMessage: 'Racial Trait Spell',
  },
  arsenalArmiesIndexAdd: {
    id: 'arsenal.armies.index.add',
    defaultMessage: 'Create a new army',
  },
  arsenalArmiesIndexTitle: {
    id: 'arsenal.armies.index.title',
    defaultMessage: 'My miniatures',
  },
  arsenalArmyFormGameError: {
    id: 'arsenal.army.form.game.error',
    defaultMessage: 'You must select a game!',
  },
  arsenalArmyFormGamePlaceholder: {
    id: 'arsenal.army.form.game.placeholder',
    defaultMessage: 'Select a game',
  },
  arsenalArmyFormGameTitle: {
    id: 'arsenal.army.form.game.title',
    defaultMessage: 'Your game',
  },
  arsenalArmyFormArmyError: {
    id: 'arsenal.army.form.army.error',
    defaultMessage: 'You must select an army!',
  },
  arsenalArmyFormArmyPlaceholder: {
    id: 'arsenal.army.form.army.placeholder',
    defaultMessage: 'Select an army',
  },
  arsenalArmyFormArmyTitle: {
    id: 'arsenal.army.form.army.title',
    defaultMessage: 'Your army',
  },
  arsenalArmyFormNameError: {
    id: 'arsenal.army.form.name.error',
    defaultMessage: 'Your army need a name!',
  },
  arsenalArmyFormNamePlaceholder: {
    id: 'arsenal.army.form.name.placeholder',
    defaultMessage: 'My model army',
  },
  arsenalArmyFormNameTitle: {
    id: 'arsenal.army.form.name.title',
    defaultMessage: 'Name of your models',
  },
  arsenalArmyNewTitle: {
    id: 'arsenal.army.new.title',
    defaultMessage: 'Create a new army',
  },
  arsenalArmyShowComment: {
    id: 'arsenal.army.show.comment',
    defaultMessage: 'Comment',
  },
  arsenalArmyShowQuantity: {
    id: 'arsenal.army.show.quantity',
    defaultMessage: 'Quantity',
  },
  arsenalArmyShowTitle: {
    id: 'arsenal.army.show.title',
    defaultMessage: 'Your army',
  },
  arsenalArmyShowUnit: { id: 'arsenal.army.show.unit', defaultMessage: 'Unit' },
  arsenalArmyShareTitle: {
    id: 'arsenal.army.share.title',
    defaultMessage: 'Share your miniatures',
  },
  arsenalArmyShareDescription: {
    id: 'arsenal.army.share.description',
    defaultMessage:
      'If you send this link to a friend, he will be possible for him to see all your miniatures from this army:',
  },
  arsenalUnitFormCommentPlaceholder: {
    id: 'arsenal.unit.form.comment.placeholder',
    defaultMessage: 'Add a comment...',
  },
  arsenalUnitFormCommentTitle: {
    id: 'arsenal.unit.form.comment.title',
    defaultMessage: 'Comment',
  },
  arsenalUnitFormTitle: {
    id: 'arsenal.unit.form.title',
    defaultMessage: 'Add an unit',
  },
  arsenalUnitFormUnitError: {
    id: 'arsenal.unit.form.unit.error',
    defaultMessage: 'You must select an unit!',
  },
  arsenalUnitFormUnitPlaceholder: {
    id: 'arsenal.unit.form.unit.placeholder',
    defaultMessage: 'Select an unit',
  },
  arsenalUnitFormUnitTitle: {
    id: 'arsenal.unit.form.unit.title',
    defaultMessage: 'Your unit',
  },
  arsenalStepProject: { id: 'arsenal.step.Project', defaultMessage: 'Project' },
  arsenalStepBought: { id: 'arsenal.step.Bought', defaultMessage: 'Bought' },
  arsenalStepUnassembled: {
    id: 'arsenal.step.Unassembled',
    defaultMessage: 'Unassembled',
  },
  arsenalStepAssembled: {
    id: 'arsenal.step.Assembled',
    defaultMessage: 'Assembled',
  },
  arsenalStepPrimed: { id: 'arsenal.step.Primed', defaultMessage: 'Primed' },
  arsenalStepPainted: { id: 'arsenal.step.Painted', defaultMessage: 'Painted' },
  arsenalStepBased: { id: 'arsenal.step.Based', defaultMessage: 'Based' },
  builderSearchsIndexAnd: {
    id: 'builder.searchs.index.and',
    defaultMessage: 'and',
  },
  builderSearchsIndexBetween: {
    id: 'builder.searchs.index.between',
    defaultMessage: 'between',
  },
  builderSearchsIndexPoints: {
    id: 'builder.searchs.index.points',
    defaultMessage: 'points',
  },
  builderSearchsIndexSearch: {
    id: 'builder.searchs.index.search',
    defaultMessage: 'Search',
  },
  builderSearchsIndexSearchArmySelectError: {
    id: 'builder.searchs.index.search_army_select_error',
    defaultMessage: 'You must select one army',
  },
  builderSearchsIndexSelectArmy: {
    id: 'builder.searchs.index.select_army',
    defaultMessage: 'Choise the army',
  },
  builderSearchsIndexSelectPointsRange: {
    id: 'builder.searchs.index.select_points_range',
    defaultMessage: 'Number of point',
  },
  builderSearchsIndexSelectVersion: {
    id: 'builder.searchs.index.select_version',
    defaultMessage: 'Choise the version of 9Th Age',
  },
  builderSearchsIndexTitle: {
    id: 'builder.searchs.index.title',
    defaultMessage: 'Search an Army list',
  },
  builderSearchsShowAnd: {
    id: 'builder.searchs.show.and',
    defaultMessage: 'and',
  },
  builderSearchsShowBetween: {
    id: 'builder.searchs.show.between',
    defaultMessage: 'between',
  },
  builderSearchsShowPoints: {
    id: 'builder.searchs.show.points',
    defaultMessage: 'points',
  },
  builderSearchsShowTitle: {
    id: 'builder.searchs.show.title',
    defaultMessage: 'Army list found',
  },
  close: { id: 'close', defaultMessage: 'Close' },
  common: { id: 'common', defaultMessage: 'Common' },
  confirmationFormEmail: {
    id: 'confirmation.form.email',
    defaultMessage: 'Email',
  },
  confirmationFormSubmit: {
    id: 'confirmation.form.submit',
    defaultMessage: 'Save',
  },
  confirmationInformation: {
    id: 'confirmation.information',
    defaultMessage:
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
  },
  confirmationLostPassword: {
    id: 'confirmation.lost.password',
    defaultMessage: 'I have lost my password!',
  },
  confirmationTitle: {
    id: 'confirmation.title',
    defaultMessage: 'Re-send confirmation instructions',
  },
  contestBack: { id: 'contest.back', defaultMessage: 'back' },
  contestDeleteInformation: {
    id: 'contest.delete.information',
    defaultMessage: 'Are you sure to delete:',
  },
  contestDeleteSubmit: {
    id: 'contest.delete.submit',
    defaultMessage: '!!! Delete !!!',
  },
  contestDeleteTitle: {
    id: 'contest.delete.title',
    defaultMessage: 'Delete contest',
  },
  contestEditTitle: {
    id: 'contest.edit.title',
    defaultMessage: 'Edit my contest',
  },
  contestFormArmylistmaxError: {
    id: 'contest.form.armyListMax.error',
    defaultMessage: 'Your contest need a max points by army',
  },
  contestFormArmylistmaxPlaceholder: {
    id: 'contest.form.armyListMax.placeholder',
    defaultMessage: 'Enter a max points by army',
  },
  contestFormArmylistmaxTitle: {
    id: 'contest.form.armyListMax.title',
    defaultMessage: 'Max points by army',
  },
  contestFormEnddateError: {
    id: 'contest.form.endDate.error',
    defaultMessage: 'Your contest need a end date',
  },
  contestFormEnddatePlaceholder: {
    id: 'contest.form.endDate.placeholder',
    defaultMessage: 'Enter a end date',
  },
  contestFormEnddateTitle: {
    id: 'contest.form.endDate.title',
    defaultMessage: 'End date *',
  },
  contestFormNameError: {
    id: 'contest.form.name.error',
    defaultMessage: 'You must name your list',
  },
  contestFormNamePlaceholder: {
    id: 'contest.form.name.placeholder',
    defaultMessage: 'Enter a name',
  },
  contestFormNameTitle: {
    id: 'contest.form.name.title',
    defaultMessage: 'Name *',
  },
  contestFormParticipationError: {
    id: 'contest.form.participation.error',
    defaultMessage: 'Your contest need a participation mode',
  },
  contestFormParticipationPlaceholder: {
    id: 'contest.form.participation.placeholder',
    defaultMessage: 'Enter a participation mode',
  },
  contestFormParticipationTitle: {
    id: 'contest.form.participation.title',
    defaultMessage: 'Individual or by Team',
  },
  contestFormStartdateError: {
    id: 'contest.form.startDate.error',
    defaultMessage: 'Your contest need a start date',
  },
  contestFormStartdatePlaceholder: {
    id: 'contest.form.startDate.placeholder',
    defaultMessage: 'Enter a start date',
  },
  contestFormStartdateTitle: {
    id: 'contest.form.startDate.title',
    defaultMessage: 'Start date *',
  },
  contestFormTeammaxError: {
    id: 'contest.form.teamMax.error',
    defaultMessage: 'Your contest need a number of team',
  },
  contestFormTeammaxPlaceholder: {
    id: 'contest.form.teamMax.placeholder',
    defaultMessage: 'Enter a number of team',
  },
  contestFormTeammaxTitle: {
    id: 'contest.form.teamMax.title',
    defaultMessage: 'Number of team',
  },
  contestFormUsermaxError: {
    id: 'contest.form.userMax.error',
    defaultMessage: 'Your contest need a number of participant or team size',
  },
  contestFormUsermaxPlaceholder: {
    id: 'contest.form.userMax.placeholder',
    defaultMessage: 'Enter a number of participant or team size',
  },
  contestFormUsermaxTitle: {
    id: 'contest.form.userMax.title',
    defaultMessage: 'Number of participant or team size',
  },
  contestFormVersionidError: {
    id: 'contest.form.versionid.error',
    defaultMessage: 'Your contest need a game version',
  },
  contestFormVersionidPlaceholder: {
    id: 'contest.form.versionid.placeholder',
    defaultMessage: 'Enter a game version',
  },
  contestFormVersionidTitle: {
    id: 'contest.form.versionid.title',
    defaultMessage: 'Game version *',
  },
  contestName: { id: 'contest.name', defaultMessage: 'Tournament' },
  contestNewTitle: {
    id: 'contest.new.title',
    defaultMessage: 'Create a contest',
  },
  contestShowTitle: {
    id: 'contest.show.title',
    defaultMessage: 'Contest: {name}',
  },
  dataAnalyticsAnalyticsTitle: {
    id: 'data_analytics.analytics.title',
    defaultMessage: 'Project: Better data for T9A',
  },
  dataAnalyticsReportNewTitle: {
    id: 'data_analytics.report.new.title',
    defaultMessage: 'Report a game',
  },
  modelRulesIndexShow: { id: 'model_rules.index.show', defaultMessage: 'Show' },
  modelRulesIndexTitle: {
    id: 'model_rules.index.title',
    defaultMessage: 'Model Rules',
  },
  exportFormat: { id: 'export.format', defaultMessage: 'Format' },
  exportFull: { id: 'export.full', defaultMessage: 'Full' },
  exportLite: { id: 'export.lite', defaultMessage: 'Lite' },
  exportMagics: { id: 'export.magics', defaultMessage: 'Magics' },
  exportNomagics: { id: 'export.nomagics', defaultMessage: 'No Magics' },
  exportPrint: { id: 'export.print', defaultMessage: 'print' },
  exportVerbosity: { id: 'export.verbosity', defaultMessage: 'Verbosity' },
  exportWithmagics: { id: 'export.withmagics', defaultMessage: 'With magics' },
  federationClubNewTitle: {
    id: 'federation.club.new.title',
    defaultMessage: 'Create or edit a club',
  },
  federationClubFormNameTitle: {
    id: 'federation.club.form.name.title',
    defaultMessage: 'Name',
  },
  federationClubFormNamePlaceholder: {
    id: 'federation.club.form.name.placeholder',
    defaultMessage: 'My club',
  },
  federationClubFormNameError: {
    id: 'federation.club.form.name.error',
    defaultMessage: 'You must name your club',
  },
  federationClubFormCountryTitle: {
    id: 'federation.club.form.country.title',
    defaultMessage: 'Country',
  },
  federationClubFormCountryPlaceholder: {
    id: 'federation.club.form.country.placeholder',
    defaultMessage: 'Which country ?',
  },
  federationClubFormCountryError: {
    id: 'federation.club.form.country.error',
    defaultMessage: 'You must select a country',
  },
  federationClubFormLocationTitle: {
    id: 'federation.club.form.location.title',
    defaultMessage: 'Where ?',
  },
  federationClubFormLocationPlaceholder: {
    id: 'federation.club.form.location.placeholder',
    defaultMessage: 'My club is ...',
  },
  federationClubFormLocationError: {
    id: 'federation.club.form.location.error',
    defaultMessage: 'You must add a location',
  },
  federationClubFormNotesTitle: {
    id: 'federation.club.form.notes.title',
    defaultMessage: 'Information',
  },
  federationClubFormNotesPlaceholder: {
    id: 'federation.club.form.notes.placeholder',
    defaultMessage: 'Describe my club ...',
  },
  federationClubFormContactTitle: {
    id: 'federation.club.form.contact.title',
    defaultMessage: 'Contact',
  },
  federationClubFormContactPlaceholder: {
    id: 'federation.club.form.contact.placeholder',
    defaultMessage: 'Who contact ?',
  },
  federationClubFormContactError: {
    id: 'federation.club.form.contact.error',
    defaultMessage: 'You must add a contact',
  },
  federationClubFormMembersTitle: {
    id: 'federation.club.form.members.title',
    defaultMessage: 'How many ?',
  },
  federationClubFormMembersPlaceholder: {
    id: 'federation.club.form.members.placeholder',
    defaultMessage: 'We are ....',
  },
  federationClubFormMeetsTitle: {
    id: 'federation.club.form.meets.title',
    defaultMessage: 'When ?',
  },
  federationClubFormMeetsPlaceholder: {
    id: 'federation.club.form.meets.placeholder',
    defaultMessage: 'We can meet us ...',
  },
  federationClubFormWebsiteTitle: {
    id: 'federation.club.form.website.title',
    defaultMessage: 'Website',
  },
  federationClubFormWebsitePlaceholder: {
    id: 'federation.club.form.website.placeholder',
    defaultMessage: 'https://www.myclub.com',
  },
  federationClubFormCategoryTitle: {
    id: 'federation.club.form.category.title',
    defaultMessage: 'Game',
  },
  federationClubFormCategoryPlaceholder: {
    id: 'federation.club.form.category.placeholder',
    defaultMessage: 'Select a played game',
  },
  folderAddArmyListFormSelect: {
    id: 'folder.add_army_list.form.select',
    defaultMessage: 'Select an army list',
  },
  folderAddArmyListTitle: {
    id: 'folder.add_army_list.title',
    defaultMessage: 'Add a list into this folder',
  },
  folderBack: { id: 'folder.back', defaultMessage: 'back' },
  folderDeleteInformation: {
    id: 'folder.delete.information',
    defaultMessage: 'Are you sure to delete:',
  },
  folderDeleteSubmit: {
    id: 'folder.delete.submit',
    defaultMessage: '!!! Delete !!!',
  },
  folderDeleteTitle: {
    id: 'folder.delete.title',
    defaultMessage: 'Delete folder',
  },
  folderEditTitle: {
    id: 'folder.edit.title',
    defaultMessage: 'Edit my folder',
  },
  folderFormIsShareTitle: {
    id: 'folder.form.is_share.title',
    defaultMessage: 'Share this folder',
  },
  folderFormNameError: {
    id: 'folder.form.name.error',
    defaultMessage: 'You must name your list',
  },
  folderFormNamePlaceholder: {
    id: 'folder.form.name.placeholder',
    defaultMessage: 'Enter a name',
  },
  folderFormNameTitle: {
    id: 'folder.form.name.title',
    defaultMessage: 'Name *',
  },
  folderFormParentPlaceholder: {
    id: 'folder.form.parent.placeholder',
    defaultMessage: 'Select the parent',
  },
  folderFormParentTitle: {
    id: 'folder.form.parent.title',
    defaultMessage: 'Parent',
  },
  folderName: { id: 'folder.name', defaultMessage: 'Folder' },
  folderNewTitle: { id: 'folder.new.title', defaultMessage: 'Create a folder' },
  folderShareTitle: {
    id: 'folder.share.title',
    defaultMessage: 'Share folder',
  },
  folderShowTitle: {
    id: 'folder.show.title',
    defaultMessage: 'Folder: {name}',
  },
  folderTournamentInformation: {
    id: 'folder.tournament.information',
    defaultMessage: 'You can convert this folder into a tournament!',
  },
  folderTournamentSubmit: {
    id: 'folder.tournament.submit',
    defaultMessage: '!!! Create !!!',
  },
  folderTournamentTitle: {
    id: 'folder.tournament.title',
    defaultMessage: 'Create a tournament',
  },
  footerlinkAccessibility: {
    id: 'footerlink.accessibility',
    defaultMessage: 'Accessibility',
  },
  footerlinkPrivacy: {
    id: 'footerlink.privacy',
    defaultMessage: 'Privacy Policy',
  },
  formAdd: { id: 'form.add', defaultMessage: 'Add' },
  formCancel: { id: 'form.cancel', defaultMessage: 'Cancel' },
  formClone: { id: 'form.clone', defaultMessage: 'Duplicate' },
  formCreate: { id: 'form.create', defaultMessage: 'Create' },
  formDelete: { id: 'form.delete', defaultMessage: 'Delete' },
  formEdit: { id: 'form.edit', defaultMessage: 'Edit' },
  formFormat: { id: 'form.format', defaultMessage: 'Format' },
  formImport: { id: 'form.import', defaultMessage: 'Import' },
  formSave: { id: 'form.save', defaultMessage: 'Save' },
  formValidate: { id: 'form.validate', defaultMessage: 'Validate' },
  formBuild: { id: 'form.build', defaultMessage: 'Build' },
  formSend: { id: 'form.send', defaultMessage: 'Send' },
  formSearch: { id: 'form.search', defaultMessage: 'Search' },
  formShare: { id: 'form.share', defaultMessage: 'Share' },
  locationCenter: { id: 'location.center', defaultMessage: 'Center:' },
  locationDisplayLocation: {
    id: 'location.display.location',
    defaultMessage: 'Show your location',
  },
  locationDisplayRefresh: {
    id: 'location.display.refresh',
    defaultMessage: 'Refresh your location',
  },
  locationShareDescription: {
    id: 'location.share.description',
    defaultMessage: 'Do you want to show your location to others players?',
  },
  locationShareInfo: {
    id: 'location.share.info',
    defaultMessage: 'Only location, name and favorite game will be displayed.',
  },
  formatFormDateError: {
    id: 'format.form.date.error',
    defaultMessage: 'You must select a creation date for your list',
  },
  formatFormDatePlaceholder: {
    id: 'format.form.date.placeholder',
    defaultMessage: '01/01/2022',
  },
  formatFormDateTitle: {
    id: 'format.form.date.title',
    defaultMessage: 'Creation date *',
  },
  formatFormFormatedTitle: {
    id: 'format.form.formated.title',
    defaultMessage: 'Your formated army list',
  },
  formatFormGameError: {
    id: 'format.form.game.error',
    defaultMessage: "You must select the game's name that you want to play",
  },
  formatFormGamePlaceholder: {
    id: 'format.form.game.placeholder',
    defaultMessage: 'T9A, EoW, WHB,....',
  },
  formatFormGameTitle: {
    id: 'format.form.game.title',
    defaultMessage: 'Your game *',
  },
  formatFormSourceError: {
    id: 'format.form.source.error',
    defaultMessage: 'You must add your list',
  },
  formatFormSourcePlaceholder: {
    id: 'format.form.source.placeholder',
    defaultMessage: 'Enter an army list',
  },
  formatFormSourceTitle: {
    id: 'format.form.source.title',
    defaultMessage: 'Your army list *',
  },
  formatNewTitle: {
    id: 'format.new.title',
    defaultMessage: 'Format and Import an army list',
  },
  help: { id: 'help', defaultMessage: 'help' },
  homeAppAvailableGoogle: {
    id: 'home.app.available.google',
    defaultMessage: 'Get it on Google Play',
  },
  homeAppAvailableOnPlatform: {
    id: 'home.app.available.on_platform',
    defaultMessage: 'Currently under development, available on:',
  },
  homeAppMobile: { id: 'home.app.mobile', defaultMessage: 'A mobile app' },
  homeLocaleAvailable: {
    id: 'home.locale.available',
    defaultMessage: '9ThBuilder is available in several languages.',
  },
  homeLocaleDefault: {
    id: 'home.locale.default',
    defaultMessage:
      'By default, if the content is not available in the language you have chosen, the English content will automatically be displayed.',
  },
  homeNoAccount: {
    id: 'home.no_account',
    defaultMessage:
      'You can now use all the features of 9ThBuilder without having to create an account first. \nBe careful however, your lists are linked to your local session and therefore will not be available on another browser and may be lost if you delete your cache or your session."\n',
  },
  homeWelcome: { id: 'home.welcome', defaultMessage: '9TH BUILDER' },
  homeWhoareweCardmagic: {
    id: 'home.whoarewe.cardmagic',
    defaultMessage: 'Magic cards',
  },
  homeWhoareweCompose: {
    id: 'home.whoarewe.compose',
    defaultMessage: 'Compose and archive your favorite armies!',
  },
  homeWhoareweDescriptionSmall: {
    id: 'home.whoarewe.description_small',
    defaultMessage:
      '9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them for T9A, Old World, Warhammer Battle and Essence of War\n',
  },
  homeWhoareweDescription: {
    id: 'home.whoarewe.description',
    defaultMessage:
      'A passionate of Battle since many years. I took the 9Th Builder since several years, creates a mobile application and helps the 9Th Age administration.\nHelped by Kaos War who greatly contributed to enter army lists and for the new homePage.\n9Th Builder is an effective and easy-to-use tool for creating your army lists and sharing them. It does not generate any income :)\n',
  },
  homeWhoareweDiscord: {
    id: 'home.whoarewe.discord',
    defaultMessage: 'Discord',
  },
  homeWhoareweDraft: {
    id: 'home.whoarewe.draft',
    defaultMessage: 'Make a team pairing',
  },
  homeWhoareweFormat: {
    id: 'home.whoarewe.format',
    defaultMessage: 'Format or import your army',
  },
  homeWhoareweList: {
    id: 'home.whoarewe.list',
    defaultMessage: 'Create an Army list',
  },
  homeWhoareweNews: { id: 'home.whoarewe.news', defaultMessage: 'News' },
  homeWhoareweNewsfb: {
    id: 'home.whoarewe.newsfb',
    defaultMessage: 'News Facebook',
  },
  homeWhoarewePaint: {
    id: 'home.whoarewe.paint',
    defaultMessage: 'Create an Paint list',
  },
  homeWhoareweReadarmy: {
    id: 'home.whoarewe.readarmy',
    defaultMessage: 'Read Army Books',
  },
  homeWhoareweReadmagic: {
    id: 'home.whoarewe.readmagic',
    defaultMessage: 'Read Magic Paths',
  },
  homeWhoareweTitle: {
    id: 'home.whoarewe.title',
    defaultMessage: 'Who are we?',
  },
  homeWhoareweTry: {
    id: 'home.whoarewe.try',
    defaultMessage: 'Do you want to try?',
  },
  homeWhoareweWhatdo: {
    id: 'home.whoarewe.whatdo',
    defaultMessage: 'What can you do?',
  },
  homeWhoareweClubs: {
    id: 'home.whoarewe.clubs',
    defaultMessage: 'Find a club',
  },
  homeWhoareweDonate: { id: 'home.whoarewe.donate', defaultMessage: 'Donate' },
  lexiconIndexShow: {
    id: 'lexicon.index.show',
    defaultMessage: 'Army books \u0026 Tools',
  },
  lexiconMagicPathsCardsIndex: {
    id: 'lexicon.magic_paths.cards.index',
    defaultMessage:
      'You can find all magic paths for the games, ordered by version.',
  },
  magicCasting: { id: 'magic.casting', defaultMessage: 'Casting' },
  magicEffect: { id: 'magic.effect', defaultMessage: 'Effect' },
  magicIndexShow: { id: 'magic.index.show', defaultMessage: 'Show' },
  magicIndexTitle: { id: 'magic.index.title', defaultMessage: 'Magics' },
  magicRange: { id: 'magic.range', defaultMessage: 'Range' },
  magicShowBack: { id: 'magic.show.back', defaultMessage: 'Back' },
  magicType: { id: 'magic.type', defaultMessage: 'Type' },
  magicDuration: { id: 'magic.duration', defaultMessage: 'Duration' },
  magicItemCategoriesIndexShow: {
    id: 'magic_item_categories.index.show',
    defaultMessage: 'Show',
  },
  magicItemCategoriesIndexTitle: {
    id: 'magic_item_categories.index.title',
    defaultMessage: 'Magic item categories',
  },
  magicItemsCbtbmw: {
    id: 'magic_items.Cbtbmw',
    defaultMessage: 'Cannot be taken by models with',
  },
  magicItemsEnchantment: {
    id: 'magic_items.Enchantment',
    defaultMessage: 'Enchantment',
  },
  magicItemsDominant: {
    id: 'magic_items.dominant',
    defaultMessage: 'Dominant',
  },
  magicItemsFootonly: {
    id: 'magic_items.footonly',
    defaultMessage: 'foot only',
  },
  magicItemsIndexShow: { id: 'magic_items.index.show', defaultMessage: 'Show' },
  magicItemsIndexTitle: {
    id: 'magic_items.index.title',
    defaultMessage: 'Magic items',
  },
  magicItemsOnly: { id: 'magic_items.only', defaultMessage: 'only' },
  magicItemsPerarmy: { id: 'magic_items.perArmy', defaultMessage: 'par Armée' },
  magicItemsTypeFigurineAll: {
    id: 'magic_items.type_figurine.All',
    defaultMessage: 'All',
  },
  magicItemsTypeFigurineAnimistebestial: {
    id: 'magic_items.type_figurine.AnimisteBestial',
    defaultMessage: 'Animiste bestial',
  },
  magicItemsTypeFigurineCharacter: {
    id: 'magic_items.type_figurine.Character',
    defaultMessage: 'Character',
  },
  magicItemsTypeFigurineFeralorc: {
    id: 'magic_items.type_figurine.FeralOrc',
    defaultMessage: 'Feral Orc',
  },
  magicItemsTypeFigurineGoblins: {
    id: 'magic_items.type_figurine.Goblins',
    defaultMessage: 'Goblins',
  },
  magicItemsTypeFigurineInfantry: {
    id: 'magic_items.type_figurine.Infantry',
    defaultMessage: 'Infantry',
  },
  magicItemsTypeFigurineKnightcommanders: {
    id: 'magic_items.type_figurine.KnightCommanders',
    defaultMessage: 'Knight Commanders',
  },
  magicItemsTypeFigurineMageonfoot: {
    id: 'magic_items.type_figurine.MageOnFoot',
    defaultMessage: 'Mage On Foot',
  },
  magicItemsTypeFigurineMarshalsmountedonhorse: {
    id: 'magic_items.type_figurine.MarshalsMountedOnHorse',
    defaultMessage: 'Marshals mounted on Horse',
  },
  magicItemsTypeFigurineModelsonchariots: {
    id: 'magic_items.type_figurine.ModelsOnChariots',
    defaultMessage: 'models on Chariots',
  },
  magicItemsTypeFigurineModelsonfoot: {
    id: 'magic_items.type_figurine.ModelsOnFoot',
    defaultMessage: 'Models on foot',
  },
  magicItemsTypeFigurineMonarchsofthedead: {
    id: 'magic_items.type_figurine.MonarchsOfTheDead',
    defaultMessage: 'Monarchs of the Dead',
  },
  magicItemsTypeFigurineMonster: {
    id: 'magic_items.type_figurine.Monster',
    defaultMessage: 'Monster',
  },
  magicItemsTypeFigurineMountedcharacter: {
    id: 'magic_items.type_figurine.MountedCharacter',
    defaultMessage: 'Mounted character',
  },
  magicItemsTypeFigurineNolargetarget: {
    id: 'magic_items.type_figurine.NoLargeTarget',
    defaultMessage: 'No large target',
  },
  magicItemsTypeFigurineParentunit: {
    id: 'magic_items.type_figurine.ParentUnit',
    defaultMessage: 'Parent Unit',
  },
  magicItemsTypeFigurineWizard: {
    id: 'magic_items.type_figurine.Wizard',
    defaultMessage: 'Wizard',
  },
  magicSpellTypeLvlA: { id: 'magic_spell.type_lvl.A', defaultMessage: 'A' },
  magicSpellTypeLvlFive: {
    id: 'magic_spell.type_lvl.Five',
    defaultMessage: '5',
  },
  magicSpellTypeLvlFour: {
    id: 'magic_spell.type_lvl.Four',
    defaultMessage: '4',
  },
  magicSpellTypeLvlOne: { id: 'magic_spell.type_lvl.One', defaultMessage: '1' },
  magicSpellTypeLvlSix: { id: 'magic_spell.type_lvl.Six', defaultMessage: '6' },
  magicSpellTypeLvlThree: {
    id: 'magic_spell.type_lvl.Three',
    defaultMessage: '3',
  },
  magicSpellTypeLvlTwo: { id: 'magic_spell.type_lvl.Two', defaultMessage: '2' },
  magicSpellTypeLvlZero: {
    id: 'magic_spell.type_lvl.Zero',
    defaultMessage: '0',
  },
  magicStandardsIndexShow: {
    id: 'magic_standards.index.show',
    defaultMessage: 'Show',
  },
  magicStandardsIndexTitle: {
    id: 'magic_standards.index.title',
    defaultMessage: 'Magic banners',
  },
  menuArmyLists: { id: 'menu.army_lists', defaultMessage: 'My army lists' },
  menuHelp: { id: 'menu.help', defaultMessage: 'Help' },
  menuLabel: { id: 'menu.label', defaultMessage: 'Main menu' },
  menuLanguagesDe: { id: 'menu.languages.de', defaultMessage: 'Germany' },
  menuLanguagesEn: { id: 'menu.languages.en', defaultMessage: 'English' },
  menuLanguagesEs: {
    id: 'menu.languages.es',
    defaultMessage: 'Spanish - Español',
  },
  menuLanguagesFr: { id: 'menu.languages.fr', defaultMessage: 'French' },
  menuLanguagesHu: { id: 'menu.languages.hu', defaultMessage: 'Hungarian' },
  menuLanguagesIt: {
    id: 'menu.languages.it',
    defaultMessage: 'Italian - Italiano',
  },
  menuLanguagesKo: { id: 'menu.languages.ko', defaultMessage: 'Korean' },
  menuLanguagesLang: { id: 'menu.languages.lang', defaultMessage: 'Language' },
  menuLanguagesPl: { id: 'menu.languages.pl', defaultMessage: 'Polish' },
  menuLanguagesRu: { id: 'menu.languages.ru', defaultMessage: 'Russian' },
  menuLanguagesSr: { id: 'menu.languages.sr', defaultMessage: 'Serbian' },
  menuLanguagesZh: { id: 'menu.languages.zh', defaultMessage: 'Chinese' },
  menuPreferences: { id: 'menu.preferences', defaultMessage: 'Preferences' },
  menuSignin: { id: 'menu.signin', defaultMessage: 'Sign in' },
  menuSignout: { id: 'menu.signout', defaultMessage: 'Sign out' },
  menuSignup: { id: 'menu.signup', defaultMessage: 'Sign up' },
  menuProfil: { id: 'menu.profil', defaultMessage: 'My Profile' },
  menuArsenal: { id: 'menu.arsenal', defaultMessage: 'My Miniatures' },
  next: { id: 'next', defaultMessage: 'Next' },
  ninthAgeMagicPathMagicCards: {
    id: 'ninth_age.magic_path.magic_cards',
    defaultMessage: 'Magic path cards',
  },
  ninthAgeArmyTranslationReferenceSheetTitle: {
    id: 'ninth_age.army.translation_reference_sheet.title',
    defaultMessage: 'Correspondence of translations with another language',
  },
  ninthAgeArmyQuikReferenceSheet: {
    id: 'ninth_age.army.quik_reference_sheet',
    defaultMessage: 'Quick Reference Sheet',
  },
  ninthAgeArmyMagicCards: {
    id: 'ninth_age.army.magic_cards',
    defaultMessage: 'Army magic cards',
  },
  ninthAgeFigurineMount: {
    id: 'ninth_age.figurine.mount',
    defaultMessage: 'Mount',
  },
  ninthAgeFigurinePts: { id: 'ninth_age.figurine.pts', defaultMessage: 'pts' },
  ninthAgeMagicItemOnlyWizardAllwizard: {
    id: 'ninth_age.magic_item.only_wizard.AllWizard',
    defaultMessage: 'Wizard only',
  },
  ninthAgeMagicItemOnlyWizardNowizard: {
    id: 'ninth_age.magic_item.only_wizard.NoWizard',
    defaultMessage: 'Cannot be taken by Wizards',
  },
  ninthAgeMagicItemOnlyWizardWizardadept: {
    id: 'ninth_age.magic_item.only_wizard.WizardAdept',
    defaultMessage: 'Wizard adept only',
  },
  ninthAgeMagicItemOnlyWizardWizardapprentice: {
    id: 'ninth_age.magic_item.only_wizard.WizardApprentice',
    defaultMessage: 'Wizard apprentice only',
  },
  ninthAgeMagicItemOnlyWizardWizardmaster: {
    id: 'ninth_age.magic_item.only_wizard.WizardMaster',
    defaultMessage: 'Wizard master only',
  },
  ninthAgeTroopOffensive: {
    id: 'ninth_age.troop.offensive',
    defaultMessage: 'Offensive',
  },
  ninthAgeUnitDefensive: {
    id: 'ninth_age.unit.defensive',
    defaultMessage: 'Defensive',
  },
  ninthAgeUnitFly: { id: 'ninth_age.unit.fly', defaultMessage: 'fly' },
  ninthAgeUnitGlobal: { id: 'ninth_age.unit.global', defaultMessage: 'Global' },
  ninthAgeUnitRules: {
    id: 'ninth_age.unit.rules',
    defaultMessage: 'Model Rules',
  },
  paintListDeleteInformation: {
    id: 'paint_list.delete.information',
    defaultMessage: 'Are you sure to destroy this list:',
  },
  paintListDeleteSubmit: {
    id: 'paint_list.delete.submit',
    defaultMessage: '!!! Delete !!!',
  },
  paintListDeleteTitle: {
    id: 'paint_list.delete.title',
    defaultMessage: 'Delete your list',
  },
  paintListEditTitle: {
    id: 'paint_list.edit.title',
    defaultMessage: 'Edit your paint list',
  },
  paintListFormArmyError: {
    id: 'paint_list.form.army.error',
    defaultMessage: 'You must select an army.',
  },
  paintListFormArmyPlaceholder: {
    id: 'paint_list.form.army.placeholder',
    defaultMessage: 'Select an army',
  },
  paintListFormArmyTitle: {
    id: 'paint_list.form.army.title',
    defaultMessage: 'Army *',
  },
  paintListFormNameError: {
    id: 'paint_list.form.name.error',
    defaultMessage: 'You must name your list',
  },
  paintListFormNamePlaceholder: {
    id: 'paint_list.form.name.placeholder',
    defaultMessage: 'Enter a name',
  },
  paintListFormNameTitle: {
    id: 'paint_list.form.name.title',
    defaultMessage: 'Name *',
  },
  paintListFormVersionError: {
    id: 'paint_list.form.version.error',
    defaultMessage: 'You must select a version.',
  },
  paintListFormVersionPlaceholder: {
    id: 'paint_list.form.version.placeholder',
    defaultMessage: 'Select a version',
  },
  paintListFormVersionTitle: {
    id: 'paint_list.form.version.title',
    defaultMessage: 'Version *',
  },
  paintListIndexAdd: {
    id: 'paint_list.index.add',
    defaultMessage: 'Create new paint list',
  },
  paintListIndexTitle: {
    id: 'paint_list.index.title',
    defaultMessage: 'My paint lists',
  },
  paintListNewTitle: {
    id: 'paint_list.new.title',
    defaultMessage: 'Create a new list',
  },
  paintListShowAssembled: {
    id: 'paint_list.show.assembled',
    defaultMessage: 'Assembled',
  },
  paintListShowBuy: { id: 'paint_list.show.buy', defaultMessage: 'Buy' },
  paintListShowComment: {
    id: 'paint_list.show.comment',
    defaultMessage: 'Comment',
  },
  paintListShowFirstColor: {
    id: 'paint_list.show.first_color',
    defaultMessage: 'First color',
  },
  paintListShowPaint: { id: 'paint_list.show.paint', defaultMessage: 'Paint' },
  paintListShowPlinth: {
    id: 'paint_list.show.plinth',
    defaultMessage: 'Plinth',
  },
  paintListShowSize: { id: 'paint_list.show.size', defaultMessage: 'Size' },
  paintListShowStateDone: {
    id: 'paint_list.show.state.done',
    defaultMessage: 'Done',
  },
  paintListShowStateWaiting: {
    id: 'paint_list.show.state.waiting',
    defaultMessage: 'Waiting',
  },
  paintListShowStateWip: {
    id: 'paint_list.show.state.wip',
    defaultMessage: 'Wip',
  },
  paintListShowTitle: {
    id: 'paint_list.show.title',
    defaultMessage: 'Your Paint list:',
  },
  paintListShowTrimmed: {
    id: 'paint_list.show.trimmed',
    defaultMessage: 'Trimmed',
  },
  paintListShowUnit: { id: 'paint_list.show.unit', defaultMessage: 'Unit' },
  paintListUnitFormCommentPlaceholder: {
    id: 'paint_list.unit.form.comment.placeholder',
    defaultMessage: 'Add a comment',
  },
  paintListUnitFormCommentTitle: {
    id: 'paint_list.unit.form.comment.title',
    defaultMessage: 'Comment',
  },
  paintListUnitFormSizeError: {
    id: 'paint_list.unit.form.size.error',
    defaultMessage: 'You must add a number of model',
  },
  paintListUnitFormSizePlaceholder: {
    id: 'paint_list.unit.form.size.placeholder',
    defaultMessage: 'Select a size',
  },
  paintListUnitFormSizeTitle: {
    id: 'paint_list.unit.form.size.title',
    defaultMessage: 'Size *',
  },
  paintListUnitFormTitle: {
    id: 'paint_list.unit.form.title',
    defaultMessage: 'Add an unit',
  },
  paintListUnitFormUnitError: {
    id: 'paint_list.unit.form.unit.error',
    defaultMessage: 'You must select an unit',
  },
  paintListUnitFormUnitPlaceholder: {
    id: 'paint_list.unit.form.unit.placeholder',
    defaultMessage: 'Select an unit',
  },
  paintListUnitFormUnitTitle: {
    id: 'paint_list.unit.form.unit.title',
    defaultMessage: 'Unit *',
  },
  passwordChangeFormConfirmation: {
    id: 'password_change.form.confirmation',
    defaultMessage: 'Password confirmation',
  },
  passwordChangeFormPassword: {
    id: 'password_change.form.password',
    defaultMessage: 'Password',
  },
  passwordChangeFormSubmit: {
    id: 'password_change.form.submit',
    defaultMessage: 'Save',
  },
  passwordChangeInformation: {
    id: 'password_change.information',
    defaultMessage:
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
  },
  passwordChangeLostConfirmation: {
    id: 'password_change.lost.confirmation',
    defaultMessage: "I didn't received my confirmation email",
  },
  passwordChangeLostPassword: {
    id: 'password_change.lost.password',
    defaultMessage: 'I have lost my password!',
  },
  passwordChangeTitle: {
    id: 'password_change.title',
    defaultMessage: 'Change your password',
  },
  passwordLostFormEmail: {
    id: 'password_lost.form.email',
    defaultMessage: 'Email',
  },
  passwordLostFormSubmit: {
    id: 'password_lost.form.submit',
    defaultMessage: 'Send me reset password instructions',
  },
  passwordLostInformation: {
    id: 'password_lost.information',
    defaultMessage:
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
  },
  passwordLostLostConfirmation: {
    id: 'password_lost.lost.confirmation',
    defaultMessage: "I didn't received my confirmation email",
  },
  passwordLostTitle: {
    id: 'password_lost.title',
    defaultMessage: 'I have lost my password',
  },
  pickerDatetimeJs: {
    id: 'picker.datetime.js',
    defaultMessage: 'YYYY.MM.DD HH:mm',
  },
  pickerDatetimeRb: {
    id: 'picker.datetime.rb',
    defaultMessage: '%Y.%m.%d %H:%M',
  },
  profileBack: { id: 'profile.back', defaultMessage: 'Previous page' },
  profileDeleteInformation: {
    id: 'profile.delete.information',
    defaultMessage:
      'You are not satisfied? \u003ca href="mailto:support@9thbuilder.com"\u003eContact us\u003c/a\u003e or',
  },
  profileDeleteLink: {
    id: 'profile.delete.link',
    defaultMessage: 'immediately destroy your account',
  },
  profileDeleteTitle: {
    id: 'profile.delete.title',
    defaultMessage: 'Account deletion',
  },
  profileFormConfirmation: {
    id: 'profile.form.confirmation',
    defaultMessage: 'Password confirmation',
  },
  profileFormEmail: {
    id: 'profile.form.email',
    defaultMessage: 'Email address',
  },
  profileFormGame: { id: 'profile.form.game', defaultMessage: 'Favorite' },
  profileFormName: {
    id: 'profile.form.name',
    defaultMessage: 'Name or nickname',
  },
  profileFormPassword: {
    id: 'profile.form.password',
    defaultMessage: 'Password',
  },
  profileFormPasswordHelp: {
    id: 'profile.form.password_help',
    defaultMessage: "Leave it empty if you don't want to change your password",
  },
  profileFormSubmit: { id: 'profile.form.submit', defaultMessage: 'Save' },
  profileFormBuilderInterface: {
    id: 'profile.form.builder_interface',
    defaultMessage: 'What interface for editing your list do you prefer?',
  },
  profileFormUseLatestVersion: {
    id: 'profile.form.use_latest_version',
    defaultMessage: 'Only use the last version of each army',
  },
  profileFormDefaultLocale: {
    id: 'profile.form.default_locale',
    defaultMessage: 'Your favorite language',
  },
  profileTitle: { id: 'profile.title', defaultMessage: 'My account' },
  save: { id: 'save', defaultMessage: 'Save' },
  searchListAssembled: {
    id: 'search_list.assembled',
    defaultMessage: 'Assembled',
  },
  searchListBuy: { id: 'search_list.buy', defaultMessage: 'Buy' },
  searchListComment: { id: 'search_list.comment', defaultMessage: 'Comment' },
  searchListFirstColor: {
    id: 'search_list.first_color',
    defaultMessage: 'First color',
  },
  searchListIndexSearch: {
    id: 'search_list.index.search',
    defaultMessage: 'Submit',
  },
  searchListIndexSearchList: {
    id: 'search_list.index.search_list',
    defaultMessage: 'Search an army list',
  },
  searchListPaint: { id: 'search_list.paint', defaultMessage: 'Paint' },
  searchListPlinth: { id: 'search_list.plinth', defaultMessage: 'Plinth' },
  searchListSize: { id: 'search_list.size', defaultMessage: 'Size' },
  searchListTrimmed: { id: 'search_list.trimmed', defaultMessage: 'Trimmed' },
  searchListUnit: { id: 'search_list.unit', defaultMessage: 'Unit' },
  signinConfirmation: {
    id: 'signin.Confirmation',
    defaultMessage: 'Confirmation',
  },
  signinFormEmail: { id: 'signin.form.email', defaultMessage: 'Email' },
  signinFormLost: { id: 'signin.form.lost', defaultMessage: 'Forgot ?' },
  signinFormPassword: {
    id: 'signin.form.password',
    defaultMessage: 'Password',
  },
  signinFormRemember: {
    id: 'signin.form.remember',
    defaultMessage: 'Remember me',
  },
  signinFormSubmit: { id: 'signin.form.submit', defaultMessage: 'Sign-in' },
  signinInformation: {
    id: 'signin.information',
    defaultMessage:
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
  },
  signinLostConfirmation: {
    id: 'signin.lost.confirmation',
    defaultMessage: "I didn't received my confirmation email",
  },
  signinLostPassword: {
    id: 'signin.lost.password',
    defaultMessage: 'I have lost my password!',
  },
  signinTitle: { id: 'signin.title', defaultMessage: 'Sign in' },
  signupFormConfirmation: {
    id: 'signup.form.confirmation',
    defaultMessage: 'Password confirmation',
  },
  signupFormEmail: { id: 'signup.form.email', defaultMessage: 'Email address' },
  signupFormGame: { id: 'signup.form.game', defaultMessage: '--Favorite--' },
  signupFormName: {
    id: 'signup.form.name',
    defaultMessage: 'Name or nickname',
  },
  signupFormPassword: {
    id: 'signup.form.password',
    defaultMessage: 'Password',
  },
  signupFormRegister: {
    id: 'signup.form.register',
    defaultMessage: 'Join us !',
  },
  signupFormSubmit: { id: 'signup.form.submit', defaultMessage: 'Sign-up' },
  signupInformation: {
    id: 'signup.information',
    defaultMessage:
      'For any questions, contact us on \u003ca href="mailto:support@9thbuilder.com"\u003eonline help\u003c/a\u003e',
  },
  signupLostConfirmation: {
    id: 'signup.lost.confirmation',
    defaultMessage: "I didn't received my confirmation email",
  },
  signupLostPassword: {
    id: 'signup.lost.password',
    defaultMessage: 'I have lost my password!',
  },
  signupTitle: { id: 'signup.title', defaultMessage: 'Sign up' },
  siteAccept: { id: 'site.accept', defaultMessage: 'I accept' },
  siteMore: { id: 'site.more', defaultMessage: 'Learn more' },
  siteUseCookie: {
    id: 'site.use_cookie',
    defaultMessage:
      'This site uses cookies to offer you the best service. By continuing your navigation, you use the use of cookies.',
  },
  toolGameHelp: { id: 'tool.game_help', defaultMessage: 'Game helpers' },
  toolPairingDone: {
    id: 'tool.pairing.done',
    defaultMessage: 'Your pairing is complete',
  },
  toolPairingDraftIndexTitle: {
    id: 'tool.pairing.draft.index.title',
    defaultMessage: 'My Drafts',
  },
  toolPairingDraftSendLink: {
    id: 'tool.pairing.draft.send_link',
    defaultMessage: 'Send this link to your opponent:',
  },
  toolPairingDraftWaitingOpponent: {
    id: 'tool.pairing.draft.waiting_opponent',
    defaultMessage: 'We are waiting your opponent',
  },
  toolPairingDrawConfirmDraw: {
    id: 'tool.pairing.draw.confirm.draw',
    defaultMessage: 'Confirm Draw',
  },
  toolPairingDrawConfirmResponse: {
    id: 'tool.pairing.draw.confirm.response',
    defaultMessage: 'Confirm Response',
  },
  toolPairingDrawConfirmSelect: {
    id: 'tool.pairing.draw.confirm.select',
    defaultMessage: 'Confirm select',
  },
  toolPairingDrawOr: { id: 'tool.pairing.draw.or', defaultMessage: 'or' },
  toolPairingDrawVs: { id: 'tool.pairing.draw.vs', defaultMessage: 'Vs' },
  toolPairingDrawRoundSelectDraw: {
    id: 'tool.pairing.draw_round.select.draw',
    defaultMessage: 'Select one army for the draft',
  },
  toolPairingDrawRoundSelectResponse: {
    id: 'tool.pairing.draw_round.select.response',
    defaultMessage: 'Select your reponses',
  },
  toolPairingDrawRoundSelectSelect: {
    id: 'tool.pairing.draw_round.select.select',
    defaultMessage: 'Select the army',
  },
  toolPairingDrawRoundSelectWaiting: {
    id: 'tool.pairing.draw_round.select.waiting',
    defaultMessage: 'Waiting',
  },
  toolPairingFormNameError: {
    id: 'tool.pairing.form.name.error',
    defaultMessage: 'Your must name your Team!',
  },
  toolPairingFormSizeError: {
    id: 'tool.pairing.form.size.error',
    defaultMessage: 'Your must select a size!',
  },
  toolPairingFormVersionidError: {
    id: 'tool.pairing.form.versionId.error',
    defaultMessage: 'Your must select a game version!',
  },
  toolPairingFormTablesLabel: {
    id: 'tool.pairing.form.tables.label',
    defaultMessage: 'Your tables',
  },
  toolPairingFormTablesError: {
    id: 'tool.pairing.form.tables.error',
    defaultMessage: 'Your must select yours tables!',
  },
  toolPairingFormTablesNoMaps: {
    id: 'tool.pairing.form.tables.no_maps',
    defaultMessage: 'No map available for this game',
  },
  toolPairingFormArmiesLabel: {
    id: 'tool.pairing.form.armies.label',
    defaultMessage: 'Your armies',
  },
  toolPairingFormArmiesError: {
    id: 'tool.pairing.form.armies.error',
    defaultMessage:
      'Your must select the same number of armies that the size of the draft!',
  },
  toolPairingImage: {
    id: 'tool.pairing.image',
    defaultMessage: 'Copy the pairing url image',
  },
  toolPairingInprogress: {
    id: 'tool.pairing.inprogress',
    defaultMessage: 'Your pairing is in progress',
  },
  toolPairingMatchesTables: {
    id: 'tool.pairing.matches.tables',
    defaultMessage: 'Tables:',
  },
  toolPairingMyTeamMyArmies: {
    id: 'tool.pairing.my_team.my_armies',
    defaultMessage: 'Your armies',
  },
  toolPairingOpponentTeamTeam: {
    id: 'tool.pairing.opponent_team.team',
    defaultMessage: 'Team',
  },
  toolPairingPlayerName: {
    id: 'tool.pairing.player.name',
    defaultMessage: 'Player:',
  },
  toolPairingPlayerPlaceholder: {
    id: 'tool.pairing.player.placeholder',
    defaultMessage: 'Player name',
  },
  toolPairingSelectArmiesChoiseArmies: {
    id: 'tool.pairing.select_armies.choise_armies',
    defaultMessage: 'Choise your armies',
  },
  toolPairingSelectArmiesConfirm: {
    id: 'tool.pairing.select_armies.confirm',
    defaultMessage: 'Confirm',
  },
  toolPairingSelectArmiesError: {
    id: 'tool.pairing.select_armies.error',
    defaultMessage: 'Sorry! There was an error loading the items.',
  },
  toolPairingSelectArmiesYourTeam: {
    id: 'tool.pairing.select_armies.your_team',
    defaultMessage: 'Your Team',
  },
  toolPairingSelectTeamSizeHowMany: {
    id: 'tool.pairing.select_team_size.how_many',
    defaultMessage: 'How many players in the team?',
  },
  toolPairingSelectGame: {
    id: 'tool.pairing.select_game',
    defaultMessage: 'Which game do you want to play?',
  },
  toolPairingTable: { id: 'tool.pairing.table', defaultMessage: 'Table' },
  toolPairingTeamNameConfirm: {
    id: 'tool.pairing.team.name.confirm',
    defaultMessage: 'Confirm',
  },
  toolPairingTeamNameWhatName: {
    id: 'tool.pairing.team.name.what_name',
    defaultMessage: "What's the name of your team?",
  },
  toolPairingTeamNameYourName: {
    id: 'tool.pairing.team.name.your_name',
    defaultMessage: 'Your team name',
  },
  toolSearchRulesIndexSearch: {
    id: 'tool.search_rules.index.search',
    defaultMessage: 'Search',
  },
  toolSearchRulesIndexSearchArmySelectError: {
    id: 'tool.search_rules.index.search_army_select_error',
    defaultMessage: 'You must select one army',
  },
  toolSearchRulesIndexSearchRule: {
    id: 'tool.search_rules.index.search_rule',
    defaultMessage: 'Choise one rule',
  },
  toolSearchRulesIndexSelectArmy: {
    id: 'tool.search_rules.index.select_army',
    defaultMessage: 'Choise the army',
  },
  toolSearchRulesIndexSelectVersion: {
    id: 'tool.search_rules.index.select_version',
    defaultMessage: 'Choise the version of 9Th Age',
  },
  toolSearchRulesIndexTitle: {
    id: 'tool.search_rules.index.title',
    defaultMessage: 'Search by rules',
  },
  tournamentContestBack: {
    id: 'tournament.contest.back',
    defaultMessage: 'Back to tournaments',
  },
  tournamentContestEdit: {
    id: 'tournament.contest.edit',
    defaultMessage: 'Edit',
  },
  tournamentContestFormAddress: {
    id: 'tournament.contest.form.address',
    defaultMessage: 'Address',
  },
  tournamentContestFormEndDate: {
    id: 'tournament.contest.form.end_date',
    defaultMessage: 'End',
  },
  tournamentContestFormFees: {
    id: 'tournament.contest.form.fees',
    defaultMessage: 'Fees',
  },
  tournamentContestFormName: {
    id: 'tournament.contest.form.name',
    defaultMessage: 'Name',
  },
  tournamentContestFormRoundCount: {
    id: 'tournament.contest.form.round_count',
    defaultMessage: 'Rounds',
  },
  tournamentContestFormStartDate: {
    id: 'tournament.contest.form.start_date',
    defaultMessage: 'Start',
  },
  tournamentContestFormSubmit: {
    id: 'tournament.contest.form.submit',
    defaultMessage: 'Save',
  },
  tournamentContestFormTeamMax: {
    id: 'tournament.contest.form.team_max',
    defaultMessage: 'Max teams',
  },
  tournamentContestFormUserMax: {
    id: 'tournament.contest.form.user_max',
    defaultMessage: 'Max users',
  },
  tournamentContestFormUserTeamMax: {
    id: 'tournament.contest.form.user_team_max',
    defaultMessage: 'Max users by team',
  },
  tournamentContestFormVersion: {
    id: 'tournament.contest.form.version',
    defaultMessage: 'Version',
  },
  tournamentContestIndexTitle: {
    id: 'tournament.contest.index.title',
    defaultMessage: 'My tournaments',
  },
  tournamentContestName: {
    id: 'tournament.contest.name',
    defaultMessage: 'Tournament',
  },
  tournamentContestNewTitle: {
    id: 'tournament.contest.new.title',
    defaultMessage: 'Create a tournament',
  },
  tournamentContestPrintArmies: {
    id: 'tournament.contest.print_armies',
    defaultMessage: 'Print all armies',
  },
  tournamentContestPrintRepport: {
    id: 'tournament.contest.print_repport',
    defaultMessage: 'Rapport',
  },
  tournamentContestTotal: {
    id: 'tournament.contest.total',
    defaultMessage: 'Total',
  },
  tournamentCustomPointName: {
    id: 'tournament.custom_point.name',
    defaultMessage: 'Paint, Wysiwyg, List',
  },
  tournamentRoundAdd: {
    id: 'tournament.round.add',
    defaultMessage: 'Add round',
  },
  tournamentRoundName: { id: 'tournament.round.name', defaultMessage: 'Round' },
  tournamentRoundPoolsValidate: {
    id: 'tournament.round.pools.validate',
    defaultMessage: 'Create pools',
  },
  tournamentTeamAdd: { id: 'tournament.team.add', defaultMessage: 'Add Team' },
  tournamentTeamBack: {
    id: 'tournament.team.back',
    defaultMessage: 'Back to teams',
  },
  tournamentTeamEditTitle: {
    id: 'tournament.team.edit.title',
    defaultMessage: 'Edition team',
  },
  tournamentTeamExportTitle: {
    id: 'tournament.team.export.title',
    defaultMessage: 'Team',
  },
  tournamentTeamFirst: {
    id: 'tournament.team.first',
    defaultMessage: 'Add your first team',
  },
  tournamentTeamFormEmail: {
    id: 'tournament.team.form.email',
    defaultMessage: 'Email',
  },
  tournamentTeamFormName: {
    id: 'tournament.team.form.name',
    defaultMessage: 'Name',
  },
  tournamentTeamFormSubmit: {
    id: 'tournament.team.form.submit',
    defaultMessage: 'Save',
  },
  tournamentTeamIndexTitle: {
    id: 'tournament.team.index.title',
    defaultMessage: 'My Tournament teams',
  },
  tournamentTeamName: { id: 'tournament.team.name', defaultMessage: 'Teams' },
  tournamentTeamNewTitle: {
    id: 'tournament.team.new.title',
    defaultMessage: 'Add teams',
  },
  tournamentTeamsAdd: {
    id: 'tournament.teams.add',
    defaultMessage: 'Add Team',
  },
  tournamentTeamsBack: {
    id: 'tournament.teams.back',
    defaultMessage: 'Back to tournaments',
  },
  tournamentTeamsTitle: {
    id: 'tournament.teams.title',
    defaultMessage: 'Teams',
  },
  tournamentUserApplyAdd: {
    id: 'tournament.user_apply.add',
    defaultMessage: 'Add Participant',
  },
  tournamentUserApplyAddIntoTeam: {
    id: 'tournament.user_apply.add_into_team',
    defaultMessage: 'Add partipant in this team',
  },
  tournamentUserApplyArmyListAddNow: {
    id: 'tournament.user_apply.army_list.add_now',
    defaultMessage: 'Add it now!',
  },
  tournamentUserApplyArmyListCreate: {
    id: 'tournament.user_apply.army_list.create',
    defaultMessage: 'Create a new list',
  },
  tournamentUserApplyArmyListNeed: {
    id: 'tournament.user_apply.army_list.need',
    defaultMessage: 'You have not added your army list yet.',
  },
  tournamentUserApplyArmyListOr: {
    id: 'tournament.user_apply.army_list.or',
    defaultMessage: 'or',
  },
  tournamentUserApplyArmyListUseExisting: {
    id: 'tournament.user_apply.army_list.use_existing',
    defaultMessage: 'Use an existing list',
  },
  tournamentUserApplyArmyListWhich: {
    id: 'tournament.user_apply.army_list.which',
    defaultMessage: 'Which army list ?',
  },
  tournamentUserApplyArmyListSelectFormSubmit: {
    id: 'tournament.user_apply.army_list_select.form.submit',
    defaultMessage: 'Save',
  },
  tournamentUserApplyEditTitle: {
    id: 'tournament.user_apply.edit.title',
    defaultMessage: 'Edit your participation',
  },
  tournamentUserApplyFirst: {
    id: 'tournament.user_apply.first',
    defaultMessage: 'Add your first Participant',
  },
  tournamentUserApplyFormArmyidPlaceholder: {
    id: 'tournament.user_apply.form.armyId.placeholder',
    defaultMessage: 'Player army',
  },
  tournamentUserApplyFormArmyidTitle: {
    id: 'tournament.user_apply.form.armyId.title',
    defaultMessage: 'Army',
  },
  tournamentUserApplyFormEmailPlaceholder: {
    id: 'tournament.user_apply.form.email.placeholder',
    defaultMessage: 'Player email',
  },
  tournamentUserApplyFormEmailTitle: {
    id: 'tournament.user_apply.form.email.title',
    defaultMessage: 'email',
  },
  tournamentUserApplyFormNameError: {
    id: 'tournament.user_apply.form.name.error',
    defaultMessage: 'Player name is required',
  },
  tournamentUserApplyFormNamePlaceholder: {
    id: 'tournament.user_apply.form.name.placeholder',
    defaultMessage: 'Player name',
  },
  tournamentUserApplyFormNameTitle: {
    id: 'tournament.user_apply.form.name.title',
    defaultMessage: 'Name',
  },
  tournamentUserApplyFormNameDetail: {
    id: 'tournament.user_apply.form.name_detail',
    defaultMessage:
      'You can add somes users (1 user by line) with email separated by a comma (name, email).',
  },
  tournamentUserApplyFormOr: {
    id: 'tournament.user_apply.form.or',
    defaultMessage: 'or',
  },
  tournamentUserApplyFormSubmit: {
    id: 'tournament.user_apply.form.submit',
    defaultMessage: 'Add',
  },
  tournamentUserApplyFormUser: {
    id: 'tournament.user_apply.form.user',
    defaultMessage: 'User',
  },
  tournamentUserApplyManage: {
    id: 'tournament.user_apply.manage',
    defaultMessage: 'Manage Team',
  },
  tournamentUserApplyName: {
    id: 'tournament.user_apply.name',
    defaultMessage: 'User',
  },
  tournamentUserApplyNewTitle: {
    id: 'tournament.user_apply.new.title',
    defaultMessage: 'Add users',
  },
  tournamentUserApplyRemove: {
    id: 'tournament.user_apply.remove',
    defaultMessage: 'Remove Participant',
  },
  tournamentUserApplyShareLink: {
    id: 'tournament.user_apply.share_link',
    defaultMessage: 'Share invitation link',
  },
  tournamentUserApplyTeamLeader: {
    id: 'tournament.user_apply.team_leader',
    defaultMessage: 'Is the team captain',
  },
  unitBaseHundredhundredfifty: {
    id: 'unit.base.HundredHundredFifty',
    defaultMessage: '100x150mm',
  },
  unitBaseEightyeighty: {
    id: 'unit.base.EightyEighty',
    defaultMessage: '80x80mm',
  },
  unitBaseFiftyfifty: { id: 'unit.base.FiftyFifty', defaultMessage: '50x50mm' },
  unitBaseFiftyhundred: {
    id: 'unit.base.FiftyHundred',
    defaultMessage: '50x100mm',
  },
  unitBaseFiftyseventyfive: {
    id: 'unit.base.FiftySeventyFive',
    defaultMessage: '50x75mm',
  },
  unitBaseFortyforty: { id: 'unit.base.FortyForty', defaultMessage: '40x40mm' },
  unitBaseFortyround: {
    id: 'unit.base.FortyRound',
    defaultMessage: '40mm round',
  },
  unitBaseFortysixty: { id: 'unit.base.FortySixty', defaultMessage: '40x60mm' },
  unitBaseFortytwenty: {
    id: 'unit.base.FortyTwenty',
    defaultMessage: '40x20mm',
  },
  unitBaseHundredfifty: {
    id: 'unit.base.HundredFifty',
    defaultMessage: '100x50mm',
  },
  unitBaseHundredfiftyhundred: {
    id: 'unit.base.HundredFiftyHundred',
    defaultMessage: '150x100mm',
  },
  unitBaseHundredhundred: {
    id: 'unit.base.HundredHundred',
    defaultMessage: '100x100mm',
  },
  unitBaseSeventyfivefifty: {
    id: 'unit.base.SeventyFiveFifty',
    defaultMessage: '75x50mm',
  },
  unitBaseSeventyfivehundred: {
    id: 'unit.base.SeventyFiveHundred',
    defaultMessage: '75x100mm',
  },
  unitBaseSeventyfiveround: {
    id: 'unit.base.SeventyFiveRound',
    defaultMessage: '75mm round',
  },
  unitBaseSixtyhundred: {
    id: 'unit.base.SixtyHundred',
    defaultMessage: '60x100mm',
  },
  unitBaseSixtyround: {
    id: 'unit.base.SixtyRound',
    defaultMessage: '60mm round',
  },
  unitBaseTwentyfivefifty: {
    id: 'unit.base.TwentyFiveFifty',
    defaultMessage: '25x50mm',
  },
  unitBaseTwentyfiveround: {
    id: 'unit.base.TwentyFiveRound',
    defaultMessage: '25mm round',
  },
  unitBaseTwentyfivetwentyfive: {
    id: 'unit.base.TwentyFiveTwentyFive',
    defaultMessage: '25x25mm',
  },
  unitBaseTwentytwenty: {
    id: 'unit.base.TwentyTwenty',
    defaultMessage: '20x20mm',
  },
  unitBaseSeventyfiveseventyfive: {
    id: 'unit.base.SeventyFiveSeventyFive',
    defaultMessage: '75x75mm',
  },
  unitBaseHundredtwohundred: {
    id: 'unit.base.HundredTwoHundred',
    defaultMessage: '100x200mm',
  },
  unitBaseLabel: { id: 'unit.base.label', defaultMessage: 'Base' },
  unitHeightGigantic: {
    id: 'unit.height.Gigantic',
    defaultMessage: 'Gigantic',
  },
  unitHeightLarge: { id: 'unit.height.Large', defaultMessage: 'Large' },
  unitHeightStandard: {
    id: 'unit.height.Standard',
    defaultMessage: 'Standard',
  },
  unitLimitModel: { id: 'unit.limit.model', defaultMessage: 'Units by Army' },
  unitLimitPerarmy: { id: 'unit.limit.perArmy', defaultMessage: 'par Armée' },
  unitLimitSingle: { id: 'unit.limit.single', defaultMessage: 'single model' },
  unitLimitUnit: { id: 'unit.limit.unit', defaultMessage: 'Units/Army' },
  unitMount: { id: 'unit.mount', defaultMessage: 'Mount' },
  unitShowAddModel: {
    id: 'unit.show.add_model',
    defaultMessage:
      ' + \u003cstrong\u003e{pts}\u003c/strong\u003e pts/extra model',
  },
  unitShowChangeNoMax: {
    id: 'unit.show.change.no_max',
    defaultMessage: 'Units {change}',
  },
  unitShowChangeMax: {
    id: 'unit.show.change.max',
    defaultMessage: 'A maximum of {max} units {change}',
  },
  unitShowChangeLimit: {
    id: 'unit.show.change.limit',
    defaultMessage: ' without {limit}',
  },
  unitShowChangeToMin: {
    id: 'unit.show.change.to_min',
    defaultMessage:
      'of {number} or more models{limit} count towards {new_name} instead of {old_name}.',
  },
  unitShowChangeToMax: {
    id: 'unit.show.change.to_max',
    defaultMessage:
      'of {number} or less models{limit} count towards {new_name} instead of {old_name}.',
  },
  unitShowSize: {
    id: 'unit.show.size',
    defaultMessage:
      '\u003cstrong\u003e{min_size}-{max_size}\u003c/strong\u003e models',
  },
  unitSizeGigantic: { id: 'unit.size.Gigantic', defaultMessage: 'Gigantic' },
  unitSizeLarge: { id: 'unit.size.Large', defaultMessage: 'Large' },
  unitSizeStandard: { id: 'unit.size.Standard', defaultMessage: 'Standard' },
  unitSizeLabel: { id: 'unit.size.label', defaultMessage: 'Height' },
  unitTypeLabel: { id: 'unit.type.label', defaultMessage: 'Type' },
  unitOptionPerModel: { id: 'unit_option.per_model', defaultMessage: '/mod.' },
  unitOptionUsePointsFree: {
    id: 'unit_option.use_points.free',
    defaultMessage: 'free',
  },
  unitOptionUsePointsNoLimit: {
    id: 'unit_option.use_points.no_limit',
    defaultMessage: 'no limit',
  },
  unitOptionUsePointsUpTo: {
    id: 'unit_option.use_points.up_to',
    defaultMessage: 'up to',
  },
  userProfileFavoritGame: {
    id: 'user.profile.favorit_game',
    defaultMessage: 'Your favorite game is',
  },
  userProfilePrefertUser: {
    id: 'user.profile.prefert_user',
    defaultMessage: 'You prefert use',
  },
  userProfileFavoritBuilderInterface: {
    id: 'user.profile.favorit_builder_interface',
    defaultMessage: 'interface for building your army',
  },
  userProfileUseLatestArmy: {
    id: 'user.profile.use_latest_army',
    defaultMessage: 'You use the last version of each army:',
  },
  userProfileDefaultLocale: {
    id: 'user.profile.default_locale',
    defaultMessage: 'Your default language is:',
  },
  userProfileEdit: {
    id: 'user.profile.edit',
    defaultMessage: 'Edit your Profile',
  },
  userPasswordEdit: {
    id: 'user.password.edit',
    defaultMessage: 'Change your password',
  },
  userUserBugReportNewTitle: {
    id: 'user.user_bug_report.new.title',
    defaultMessage: 'Report a bug',
  },
  userUserBugReportFormReasonTypeTitle: {
    id: 'user.user_bug_report.form.reason_type.title',
    defaultMessage: 'What the reason?*',
  },
  userUserBugReportFormReasonTypePlaceholder: {
    id: 'user.user_bug_report.form.reason_type.placeholder',
    defaultMessage: 'Can you give me the reason?',
  },
  userUserBugReportFormReasonTypeError: {
    id: 'user.user_bug_report.form.reason_type.error',
    defaultMessage: 'You must select a reason',
  },
  userUserBugReportFormReportTitle: {
    id: 'user.user_bug_report.form.report.title',
    defaultMessage: 'What the problem?*',
  },
  userUserBugReportFormReportPlaceholder: {
    id: 'user.user_bug_report.form.report.placeholder',
    defaultMessage: 'Can you give me the problem?',
  },
  userUserBugReportFormReportError: {
    id: 'user.user_bug_report.form.report.error',
    defaultMessage: 'You must give a problem',
  },
  userUserBugReportFormUnitIdTitle: {
    id: 'user.user_bug_report.form.unit_id.title',
    defaultMessage: 'The unit',
  },
  userUserBugReportFormUnitIdPlaceholder: {
    id: 'user.user_bug_report.form.unit_id.placeholder',
    defaultMessage: 'Can you give me the unit?',
  },
  userUserBugReportFormUnitOptionIdTitle: {
    id: 'user.user_bug_report.form.unit_option_id.title',
    defaultMessage: 'The option',
  },
  userUserBugReportFormUnitOptionIdPlaceholder: {
    id: 'user.user_bug_report.form.unit_option_id.placeholder',
    defaultMessage: 'Can you give me the option?',
  },
  userUserBugReportFormValueTitle: {
    id: 'user.user_bug_report.form.value.title',
    defaultMessage: 'Correct value',
  },
  userUserBugReportFormValuePlaceholder: {
    id: 'user.user_bug_report.form.value.placeholder',
    defaultMessage: 'Can you give me the correct value?',
  },
  unitOptionsCategoryC: { id: 'unit_options.category.C', defaultMessage: 'C' },
  unitOptionsCategoryM: { id: 'unit_options.category.M', defaultMessage: 'M' },
  unitOptionsCategoryS: { id: 'unit_options.category.S', defaultMessage: 'S' },
  unitOptionsFootonly: {
    id: 'unit_options.footonly',
    defaultMessage: 'foot only',
  },
  versionIndexPairing: {
    id: 'version.index.pairing',
    defaultMessage: 'Team Pairing',
  },
  versionIndexSearch: {
    id: 'version.index.search',
    defaultMessage: 'Search by rule',
  },
  versionIndexShow: { id: 'version.index.show', defaultMessage: 'Show' },
  versionIndexTitle: { id: 'version.index.title', defaultMessage: 'Versions' },
  versionIndexTools: { id: 'version.index.tools', defaultMessage: 'Tools' },
  versionShowBack: { id: 'version.show.back', defaultMessage: 'Back' },
  welcome: { id: 'welcome', defaultMessage: 'Welcome' },
  with: { id: 'with', defaultMessage: 'with %' },
  without: { id: 'without', defaultMessage: 'without %' },
  simulatorUnitMount: {
    id: 'simulator.unit.mount',
    defaultMessage: '{name} on {mount}',
  },
  simulatorUnitEquipment: {
    id: 'simulator.unit.equipment',
    defaultMessage: '{name} with {equipment}',
  },
  surveyCampaignIndexAvailableTitle: {
    id: 'survey.campaign.index.available.title',
    defaultMessage: 'Available campaings',
  },
  surveyCampaignIndexOldTitle: {
    id: 'survey.campaign.index.old.title',
    defaultMessage: 'Old campaings',
  },
  publicationArmyBooksIndexTitle: {
    id: 'publication.army_books.index.title',
    defaultMessage: 'All Armies',
  },
  publicationArmyBookFormNameLabel: {
    id: 'publication.army_book.form.name.label',
    defaultMessage: 'Name',
  },
  publicationArmyBookFormNamePlaceholder: {
    id: 'publication.army_book.form.name.placeholder',
    defaultMessage: 'Enter a name',
  },
  publicationArmyBookFormPrefixLabel: {
    id: 'publication.army_book.form.prefix.label',
    defaultMessage: 'Prefix',
  },
  publicationArmyBookFormPrefixPlaceholder: {
    id: 'publication.army_book.form.prefix.placeholder',
    defaultMessage: 'Enter a prefix',
  },
  publicationArmyBookFormVersionLabel: {
    id: 'publication.army_book.form.version.label',
    defaultMessage: 'Version',
  },
  publicationArmyBookFormVersionPlaceholder: {
    id: 'publication.army_book.form.version.placeholder',
    defaultMessage: 'Enter a version',
  },
  publicationArmyBookFormLogoPathLabel: {
    id: 'publication.army_book.form.logo_path.label',
    defaultMessage: 'Logo path',
  },
  publicationArmyBookFormLogoPathPlaceholder: {
    id: 'publication.army_book.form.logo_path.placeholder',
    defaultMessage: 'Enter a logo path',
  },
  publicationArmyBookFormCategoryNameLabel: {
    id: 'publication.army_book.form.category.name.label',
    defaultMessage: 'Name',
  },
  publicationArmyBookFormCategoryNamePlaceholder: {
    id: 'publication.army_book.form.category.name.placeholder',
    defaultMessage: 'Enter a name',
  },
  publicationArmyBookFormCategoryLogoLabel: {
    id: 'publication.army_book.form.category.logo.label',
    defaultMessage: 'Logo',
  },
  publicationArmyBookFormCategoryLogoPlaceholder: {
    id: 'publication.army_book.form.category.logo.placeholder',
    defaultMessage: 'Enter a logo',
  },
  publicationArmyBookFormCategoryValueLabel: {
    id: 'publication.army_book.form.category.value.label',
    defaultMessage: 'Value',
  },
  publicationArmyBookFormCategoryValuePlaceholder: {
    id: 'publication.army_book.form.category.value.placeholder',
    defaultMessage: 'Enter a value',
  },
  publicationArmyBookFormCategoryMinimumLabel: {
    id: 'publication.army_book.form.category.minimum.label',
    defaultMessage: 'Minimum',
  },
  publicationArmyBookFormCategoryMinimumPlaceholder: {
    id: 'publication.army_book.form.category.minimum.placeholder',
    defaultMessage: 'min or max ?',
  },
  publicationArmyBookFormMagicItemNameLabel: {
    id: 'publication.army_book.form.magic_item.name.label',
    defaultMessage: 'Name',
  },
  publicationArmyBookFormMagicItemNamePlaceholder: {
    id: 'publication.army_book.form.magic_item.name.placeholder',
    defaultMessage: 'Enter a name',
  },
  publicationArmyBookFormMagicItemTypeLabel: {
    id: 'publication.army_book.form.magic_item.type.label',
    defaultMessage: 'Type',
  },
  publicationArmyBookFormMagicItemTypePlaceholder: {
    id: 'publication.army_book.form.magic_item.type.placeholder',
    defaultMessage: 'Enter a type',
  },
  publicationArmyBookFormMagicItemCostLabel: {
    id: 'publication.army_book.form.magic_item.cost.label',
    defaultMessage: 'Cost',
  },
  publicationArmyBookFormMagicItemCostPlaceholder: {
    id: 'publication.army_book.form.magic_item.cost.placeholder',
    defaultMessage: 'Enter a cost',
  },
  publicationArmyBookFormMagicItemSupportLabel: {
    id: 'publication.army_book.form.magic_item.support.label',
    defaultMessage: 'Support',
  },
  publicationArmyBookFormMagicItemSupportPlaceholder: {
    id: 'publication.army_book.form.magic_item.support.placeholder',
    defaultMessage: 'Enter a support',
  },
  publicationArmyBookFormMagicItemRarityLabel: {
    id: 'publication.army_book.form.magic_item.rarity.label',
    defaultMessage: 'Rarity',
  },
  publicationArmyBookFormMagicItemRarityPlaceholder: {
    id: 'publication.army_book.form.magic_item.rarity.placeholder',
    defaultMessage: 'Enter a rarity',
  },
  publicationArmyBookFormMagicItemDominantLabel: {
    id: 'publication.army_book.form.magic_item.dominant.label',
    defaultMessage: 'Dominant',
  },
  publicationArmyBookFormMagicItemDominantPlaceholder: {
    id: 'publication.army_book.form.magic_item.dominant.placeholder',
    defaultMessage: 'If Dominant',
  },
  publicationArmyBookFormMagicItemRestrictionLabel: {
    id: 'publication.army_book.form.magic_item.restriction.label',
    defaultMessage: 'Restriction',
  },
  publicationArmyBookFormMagicItemRestrictionPlaceholder: {
    id: 'publication.army_book.form.magic_item.restriction.placeholder',
    defaultMessage: 'Enter restrictions',
  },
  publicationArmyBookFormMagicItemInheritsLabel: {
    id: 'publication.army_book.form.magic_item.inherits.label',
    defaultMessage: 'Inherits',
  },
  publicationArmyBookFormMagicItemInheritsPlaceholder: {
    id: 'publication.army_book.form.magic_item.inherits.placeholder',
    defaultMessage: 'Enter parent key',
  },
  publicationArmyBookFormArmyListNameLabel: {
    id: 'publication.army_book.form.army_list.name.label',
    defaultMessage: 'Name',
  },
  publicationArmyBookFormArmyListNamePlaceholder: {
    id: 'publication.army_book.form.army_list.name.placeholder',
    defaultMessage: 'Enter a name',
  },
  publicationArmyBookFormArmyListInheritsLabel: {
    id: 'publication.army_book.form.army_list.inherits.label',
    defaultMessage: 'Inherits',
  },
  publicationArmyBookFormArmyListInheritsPlaceholder: {
    id: 'publication.army_book.form.army_list.inherits.placeholder',
    defaultMessage: 'Enter parent key',
  },
  publicationArmyBookFormArmyListCategoriesLabel: {
    id: 'publication.army_book.form.army_list.categories.label',
    defaultMessage: 'Categories',
  },
  publicationArmyBookFormArmyListCategoriesPlaceholder: {
    id: 'publication.army_book.form.army_list.categories.placeholder',
    defaultMessage: 'Enter categories',
  },
  publicationArmyBookFormArmyListUnitSizeLabel: {
    id: 'publication.army_book.form.army_list.unit_size.label',
    defaultMessage: 'Unit size',
  },
  publicationArmyBookFormArmyListUnitSizePlaceholder: {
    id: 'publication.army_book.form.army_list.unit_size.placeholder',
    defaultMessage: 'Enter a unit size',
  },
  publicationArmyBookFormArmyListCostLabel: {
    id: 'publication.army_book.form.army_list.cost.label',
    defaultMessage: 'Cost',
  },
  publicationArmyBookFormArmyListCostPlaceholder: {
    id: 'publication.army_book.form.army_list.cost.placeholder',
    defaultMessage: 'Enter a cost',
  },
  publicationArmyBookFormArmyListHeightLabel: {
    id: 'publication.army_book.form.army_list.height.label',
    defaultMessage: 'Height',
  },
  publicationArmyBookFormArmyListHeightPlaceholder: {
    id: 'publication.army_book.form.army_list.height.placeholder',
    defaultMessage: 'Enter a height',
  },
  publicationArmyBookFormArmyListFluffLabel: {
    id: 'publication.army_book.form.army_list.fluff.label',
    defaultMessage: 'Fluff',
  },
  publicationArmyBookFormArmyListFluffPlaceholder: {
    id: 'publication.army_book.form.army_list.fluff.placeholder',
    defaultMessage: 'Enter a fluff',
  },
  publicationArmyBookFormArmyListProfileGlobalChargeRateLabel: {
    id: 'publication.army_book.form.army_list.profile.global.charge_rate.label',
    defaultMessage: 'Charge Rate',
  },
  publicationArmyBookFormArmyListProfileGlobalChargeRatePlaceholder: {
    id: 'publication.army_book.form.army_list.profile.global.charge_rate.placeholder',
    defaultMessage: 'Enter a charge rate value',
  },
  publicationArmyBookFormArmyListProfileGlobalMarchRateLabel: {
    id: 'publication.army_book.form.army_list.profile.global.march_rate.label',
    defaultMessage: 'March Rate',
  },
  publicationArmyBookFormArmyListProfileGlobalMarchRatePlaceholder: {
    id: 'publication.army_book.form.army_list.profile.global.march_rate.placeholder',
    defaultMessage: 'Enter a march rate value',
  },
  publicationArmyBookFormArmyListProfileGlobalDisciplineLabel: {
    id: 'publication.army_book.form.army_list.profile.global.discipline.label',
    defaultMessage: 'Discipline',
  },
  publicationArmyBookFormArmyListProfileGlobalDisciplinePlaceholder: {
    id: 'publication.army_book.form.army_list.profile.global.discipline.placeholder',
    defaultMessage: 'Enter a discipline value',
  },
  publicationArmyBookFormArmyListProfileDefensiveHpLabel: {
    id: 'publication.army_book.form.army_list.profile.defensive.hp.label',
    defaultMessage: 'HP',
  },
  publicationArmyBookFormArmyListProfileDefensiveHpPlaceholder: {
    id: 'publication.army_book.form.army_list.profile.defensive.hp.placeholder',
    defaultMessage: 'Enter a HP value',
  },
  publicationArmyBookFormArmyListProfileDefensiveDefensiveSkillLabel: {
    id: 'publication.army_book.form.army_list.profile.defensive.defensive_skill.label',
    defaultMessage: 'Defensive Skill',
  },
  publicationArmyBookFormArmyListProfileDefensiveDefensiveSkillPlaceholder: {
    id: 'publication.army_book.form.army_list.profile.defensive.defensive_skill.placeholder',
    defaultMessage: 'Enter a defensive skill value',
  },
  publicationArmyBookFormArmyListProfileDefensiveResistanceLabel: {
    id: 'publication.army_book.form.army_list.profile.defensive.resistance.label',
    defaultMessage: 'Resistance',
  },
  publicationArmyBookFormArmyListProfileDefensiveResistancePlaceholder: {
    id: 'publication.army_book.form.army_list.profile.defensive.resistance.placeholder',
    defaultMessage: 'Enter a resistance value',
  },
  publicationArmyBookFormArmyListProfileDefensiveArmourLabel: {
    id: 'publication.army_book.form.army_list.profile.defensive.armour.label',
    defaultMessage: 'Armour',
  },
  publicationArmyBookFormArmyListProfileDefensiveArmourPlaceholder: {
    id: 'publication.army_book.form.army_list.profile.defensive.armour.placeholder',
    defaultMessage: 'Enter a armour value',
  },
  publicationArmyBookFormLocNameLabel: {
    id: 'publication.army_book.form.loc.name.label',
    defaultMessage: 'LaTeX key',
  },
  publicationArmyBookFormLocNamePlaceholder: {
    id: 'publication.army_book.form.loc.name.placeholder',
    defaultMessage: 'Enter a key name',
  },
  publicationArmyBookFormLocValueLabel: {
    id: 'publication.army_book.form.loc.value.label',
    defaultMessage: 'Value',
  },
  publicationArmyBookFormLocValuePlaceholder: {
    id: 'publication.army_book.form.loc.value.placeholder',
    defaultMessage: 'Enter a translation',
  },
  publicationBooksIndexTitle: {
    id: 'publication.books.index.title',
    defaultMessage: 'Yours books',
  },
  publicationBooksIndexAdd: {
    id: 'publication.books.index.add',
    defaultMessage: 'Create a new book',
  },
  publicationBookNewTitle: {
    id: 'publication.book.new.title',
    defaultMessage: 'Create a new book',
  },
  publicationBookShowTitle: {
    id: 'publication.book.show.title',
    defaultMessage: 'Edit your book',
  },
  publicationBookBuildFormTitle: {
    id: 'publication.book.build.form.title',
    defaultMessage: 'Build your book',
  },
  publicationBookFormVersionError: {
    id: 'publication.book.form.version.error',
    defaultMessage: 'Version is required',
  },
  publicationBookFormArmyError: {
    id: 'publication.book.form.army.error',
    defaultMessage: 'Army is required',
  },
  publicationBookFormNameError: {
    id: 'publication.book.form.name.error',
    defaultMessage: 'Name is required',
  },
  publicationBookSectionTypeArmyList: {
    id: 'publication.book.section.type.ARMY_LIST',
    defaultMessage: 'Army list',
  },
  publicationBookSectionTypeArmyOrg: {
    id: 'publication.book.section.type.ARMY_ORG',
    defaultMessage: 'Army organisation',
  },
  publicationBookSectionTypeArmySpecificRule: {
    id: 'publication.book.section.type.ARMY_SPECIFIC_RULE',
    defaultMessage: 'Army specific rule',
  },
  publicationBookSectionTypeHereditarySpell: {
    id: 'publication.book.section.type.HEREDITARY_SPELL',
    defaultMessage: 'Hereditary spell',
  },
  publicationBookSectionTypeQuickRefSheet: {
    id: 'publication.book.section.type.QUICK_REF_SHEET',
    defaultMessage: 'Quick ref sheet',
  },
  publicationBookSectionTypeSpecialEquipment: {
    id: 'publication.book.section.type.SPECIAL_EQUIPMENT',
    defaultMessage: 'Special equipment',
  },
  publicationBookSectionTypeModelRule: {
    id: 'publication.book.section.type.MODEL_RULE',
    defaultMessage: 'Model rule',
  },
  publicationBookSectionCloneFormTitle: {
    id: 'publication.book.section.clone.form.title',
    defaultMessage: 'Clone this section',
  },
  publicationBookSectionDeleteFormTitle: {
    id: 'publication.book.section.delete.form.title',
    defaultMessage: 'Delete this section',
  },
  publicationBookSectionEditFormTitle: {
    id: 'publication.book.section.edit.form.title',
    defaultMessage: 'Edit this section',
  },
  publicationBookSectionFormTypeTitle: {
    id: 'publication.book.section.form.type.title',
    defaultMessage: 'Section to create',
  },
  publicationBookSectionFormTypePlaceholder: {
    id: 'publication.book.section.form.type.placeholder',
    defaultMessage: 'Select a section to create',
  },
  publicationBookSectionFormTypeError: {
    id: 'publication.book.section.form.type.error',
    defaultMessage: 'Select a selection to create',
  },
  armyAlliesTitle: { id: 'army_allies.title', defaultMessage: 'Allies' },
});

export { defaultMessages, defaultLocale };
